<template>
  <div style="margin-bottom: 100px">
    <div
      class="row"
      style="
        background: #f8f8f8;
        margin-bottom: 10px;
        border-bottom: 1px solid #96b9d0;
        padding-top: 5px;
        padding-left: 15px;
        padding-bottom: 10px;
      "
    >
      <div
        style="
          padding-right: 20px;
          font-weight: bold;
          width: 100%;
          text-align: left;
        "
      >
        Select the type of document to Modify or to Add new:
      </div>
      <div
        class="d-inline-block"
        v-for="(data, index) in modTypes"
        :key="index"
      >
        <w-button-input
          :buttonText="data.text"
          :buttonStyle="tabselectionstyle(index, data.text)"
          @onButtonClick="getTabData(index)"
        />
      </div>
    </div>

    <confirmation-modal
      v-if="triggerConfirmModalBC"
      :trigger="triggerConfirmModalBC"
      :text="lastResponseConfirmBC"
      :centered="true"
      :dontCloseWhenClickedOutside="true"
      :dontCloseWhenEscapePressed="true"
      :dontShowCloseIcon="true"
      @eventOk="callAfterConfirmModalBC()"
      @eventCancel="closeConfirmModal()"
    />
    <!-- <div class="text-left title mb-4">Awards & Certifications</div> -->
    <div v-if="activeFirstTab">
      <div style="text-align: left">
        <div
          class="d-inline-block"
          v-for="(data, index) in techModTypes"
          :key="index"
        >
          <w-button-input
            :buttonText="data.text"
            :buttonStyle="techtabselectionstyle(index, data.text)"
            @onButtonClick="getTechTabData(index)"
          />
        </div>
      </div>
      <div v-if="techActiveFirstTab == 3">
        <div class="float-right"></div>
        <li class="inner-title mb-3" style="padding-top: 30px">
          Tax Contact Details
        </li>
        <vueper-slides
          v-show="isContact"
          class="no-shadow mx-3 ml-1 mr-2"
          :visible-slides="3"
          slide-multiple
          :gap="3"
          fixed-height="300px"
          :bulletsOutside="false"
          :bullets="false"
          :slide-ratio="1 / 4"
          :dragging-distance="100"
          :breakpoints="{ 800: { visibleSlides: 2, slideMultiple: 2 } }"
        >
          <template v-slot:arrow-left>
            <img class="mx-4 slider-icon" src="@/assets/arrow_back.svg" />
          </template>
          <template v-slot:arrow-right>
            <img class="mx-4 slider-icon" src="@/assets/arrow_forward.svg" />
          </template>
          <span
            v-if="generateNoRecordFoundMessageContact(TaxContactDetails) != ''"
            >{{ generateNoRecordFoundMessageContact(TaxContactDetails) }}</span
          >
          <vueper-slide
            v-for="(contact, index1) in TaxContactDetails"
            :key="index1"
          >
            {{ selectedStatusFilterCode }}
            <template v-slot:content>
              <div class="card contact-card pl-2 pb-2 mb-2 ml-3">
                <span class="delete-card ml-auto">
                  <button
                    class="btn-border"
                    @click="editTaxContactDetail(contact)"
                  >
                    <img
                      class="mr-2 mt-1 cursor-pointer"
                      src="@/assets/edit-small.png"
                      alt="icon"
                      height="13px"
                      width="13px"
                      data-toggle="tooltip"
                      data-placement="top"
                      title="Edit"
                      animation="true"
                    />
                  </button>
                  <span v-if="contact.status == 7">
                    <button
                      class="btn-border"
                      @click="deleteContactCard(contact)"
                    >
                      <img
                        class="pr-2 mt-1 cursor-pointer"
                        src="@/assets/delete-card.svg"
                        alt="icon"
                        title="Delete"
                        animation="true"
                      />
                    </button>
                  </span>
                </span>
                <div class="diplay-heading">GST Contact Name</div>
                <div class="ml-2 answer-heading">
                  {{ contact.name ? contact.name : "-" }}
                </div>
                <i class="fa fa-phone" aria-hidden="true"></i>
                <div class="diplay-heading">GST Contact Number</div>
                <div class="ml-2 answer-heading">
                  {{ contact.mobileNumber ? contact.mobileNumber : "-" }}
                </div>
                <div class="diplay-heading">Email</div>
                <div class="ml-2 answer-heading">
                  {{ contact.email ? contact.email : "-" }}
                </div>
                <div class="diplay-heading">GST Number</div>
                <div class="ml-2 answer-heading">
                  {{ contact.gstNumber ? contact.gstNumber : "-" }}
                </div>
                <div class="diplay-heading">State</div>
                <div class="ml-2 answer-heading">
                  {{ contact.state ? contact.state : "-" }}
                </div>
              </div>
            </template>
          </vueper-slide>
        </vueper-slides>
        <p class="m-0 p-3 text-center" v-if="quickLinkDetails.contacts == 0">
          No contacts available
        </p>
      </div>
      <div v-if="techActiveFirstTab == 2">
        <div class="float-right">
          <b-button
            class="sumbit-approval"
            id="techtab2"
            :disabled="checkSubmit() || isSubmitDisable"
            @click="ConfirmSubmitForTechApproval()"
            >Submit For Technical Approval</b-button
          >
        </div>
        <div v-if="true">
          <li
            class="inner-title mb-3 mt-3"
            style="padding-top: 20px; border-top: 1px solid #ccc"
          >
            Approved Address Details
          </li>
          <div
            class="table-wrapper-scroll-y my-custom-scrollbar table-responsive"
          >
            <table class="table table-striped mb-0">
              <thead>
                <tr>
                  <th scope="col">Status</th>
                  <th scope="col">Action</th>
                  <th scope="col">Address Type</th>
                  <th scope="col">Address line</th>
                  <th scope="col">Country</th>
                  <th scope="col">State</th>
                  <th scope="col">City</th>
                  <th scope="col">Zip code</th>
                  <th scope="col">Is SEZ</th>
                  <th scope="col">Attachment</th>
                </tr>
              </thead>
              <tbody class="text-left table-body">
                <tr v-for="(addr, index) in approvedAddrList" :key="index">
                  <td scope="col" style="min-width: 95px">
                    <span :class="getStatus(1)"></span> {{ getStatus(1) }}
                  </td>
                  <td scope="col" style="width: 120px">
                    <span>
                      <button
                        class="btn-border"
                        @click="editApprovedAddrDetails(addr)"
                      >
                        Edit
                        <img
                          class="mr-2 mt-1 cursor-pointer"
                          src="@/assets/edit-small.png"
                          alt="icon"
                          height="10px"
                          width="10px"
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Edit"
                          animation="true"
                          style="margin: 0px !important"
                        />
                      </button>
                    </span>
                  </td>

                  <td scope="col">{{ addr.addressType }}</td>
                  <td scope="col" style="width: 120px">
                    {{ addr.streetAddress }}
                  </td>
                  <td scope="col">{{ addr.country }}</td>
                  <td scope="col">{{ addr.state }}</td>
                  <td scope="col">{{ addr.city }}</td>
                  <td scope="col">{{ addr.zipCode }}</td>

                  <td scope="col">{{ addr.sezTag }}</td>

                  <td scope="col">
                    <a
                      v-if="addr.documentId != null"
                      @click="showAttachFile(addr.documentId)"
                      href="#"
                      >{{ getFileName(addr.documentId) }}</a
                    >
                    <span v-else>-</span>
                  </td>
                </tr>
                <tr v-if="approvedAddrList.length == 0">
                  <td colspan="11" class="m-0 p-0">
                    <div class="m-0 p-3 text-center">
                      No address records available
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <li
            class="inner-title mb-3 mt-3"
            style="padding-top: 20px; border-top: 1px solid #ccc"
          >
            Unapproved Address Details
          </li>
          <div
            class="table-wrapper-scroll-y my-custom-scrollbar table-responsive"
          >
            <table class="table table-striped mb-0">
              <thead>
                <tr>
                  <th scope="col">Status</th>
                  <th scope="col">Action</th>
                  <th scope="col">Address Type</th>
                  <th scope="col">Address line</th>
                  <th scope="col">Country</th>
                  <th scope="col">State</th>
                  <th scope="col">City</th>
                  <th scope="col">Zip code</th>
                  <th scope="col">Is SEZ</th>
                  <th scope="col">Remarks</th>
                  <th scope="col">Reference Number</th>
                  <th scope="col">Attachment</th>
                </tr>
              </thead>
              <tbody class="text-left table-body">
                <tr v-for="(addr, index) in qlAddrList" :key="index">
                  <td scope="col" style="min-width: 95px">
                    <span :class="getStatus(addr.statusCode)"></span>
                    {{ getStatus(addr.statusCode) }}
                  </td>
                  <td scope="col" style="width: 130px; padding: 10px 0px">
                    <span
                      v-if="
                        addr.statusCode == 7 ||
                        addr.statusCode == 1 ||
                        addr.statusCode == 2
                      "
                    >
                      <button
                        class="btn-border"
                        @click="editApprovedAddrDetails(addr)"
                      >
                        Edit
                        <img
                          class="mr-2 mt-1 cursor-pointer"
                          src="@/assets/edit-small.png"
                          alt="icon"
                          height="10px"
                          width="10px"
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Edit"
                          animation="true"
                          style="margin: 0px !important"
                        />
                      </button> </span
                    ><br />
                    <span
                      v-if="
                        addr.statusCode == 7 ||
                        addr.statusCode == 3 ||
                        addr.statusCode == 2
                      "
                    >
                      <button class="btn-border" style="white-space: nowrap">
                        Delete
                        <img
                          class="pr-2 mt-1 cursor-pointer"
                          src="@/assets/delete_Icon.svg"
                          alt="icon"
                          title="Delete"
                          animation="true"
                          height="19px"
                          width="19px"
                          @click="deleteAddrDetail(addr)"
                          style="
                            margin: 0px !important;
                            padding: 0px !important;
                          "
                        />
                      </button>
                    </span>
                  </td>
                  <td scope="col" style="width: 120px">
                    {{ addr.addressType }}
                  </td>
                  <td scope="col" style="width: 120px">
                    {{ addr.streetAddress }}
                  </td>
                  <td scope="col">{{ addr.country }}</td>
                  <td scope="col">{{ addr.state }}</td>
                  <td scope="col">{{ addr.city }}</td>
                  <td scope="col">{{ addr.zipCode }}</td>

                  <td scope="col">{{ addr.sezTag }}</td>
                  <td scope="col">{{ addr.remarks }}</td>

                  <td scope="col">{{ addr.documentNumber }}</td>
                  <td scope="col">
                    <a
                      v-if="addr.documentId != null"
                      @click="showAttachFile(addr.documentId)"
                      href="#"
                      >{{ getFileName(addr.documentId) }}</a
                    >
                    <span v-else>-</span>
                  </td>
                </tr>
                <tr v-if="qlAddrList.length == 0">
                  <td colspan="11" class="m-0 p-0">
                    <div class="m-0 p-3 text-center">
                      No address records available
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="" v-if="true">
            <div
              class="col ml-3 mt-1 cursor-pointer add-button"
              v-if="!isAddMoreAddrDisabled"
              @click="addMoreAddress()"
              style="
                background: #0e5d84;
                color: #fff;
                padding: 5px 10px;
                border-radius: 5px;
                font-weight: unset;
                width: 190px;
                text-align: center;
              "
            >
              + Add More Address Details
            </div>
          </div>
        </div>
      </div>
      <div v-if="techActiveFirstTab == 1">
        <div class="float-right">
          <b-button
            class="sumbit-approval"
            id="techtab1"
            :disabled="checkSubmit() || isSubmitDisable"
            @click="ConfirmSubmitForTechApproval()"
            >Submit For Technical Approval</b-button
          >
        </div>

        <!-- <v-slide-group v-model="model" class="pa-4" active-class="success" show-arrows>
      <v-slide-item v-for="n in 15" :key="n" v-slot:default="{ active, toggle }">
        <v-card
          :color="active ? undefined : 'grey lighten-1'"
          class="ma-4"
          height="200"
          width="100"
          @click="toggle"
        >
        1234141234123
          <v-row class="fill-height" align="center" justify="center">
            <v-scale-transition>
              <v-icon v-if="active" color="white" size="48" v-text="'mdi-close-circle-outline'"></v-icon>
            </v-scale-transition>
          </v-row>
        </v-card>
      </v-slide-item>
    </v-slide-group>-->
        <!-- Printing certificates in card -->
        <br />

        <div class="row p-0 m-0 mb-2 mt-2">
          <p
            :class="activeStatusStyle === 'Approved' ? 'activeFilterTab' : ''"
            class="action-text text-left p-0 m-0 cursor-pointer"
            @click="selectedStatusDetails(1, 'A', 'Approved')"
          >
            <span class="green-dot mr-1"></span>
            Approved({{ approvedCount }})
          </p>
          <p
            :class="activeStatusStyle === 'Created' ? 'activeFilterTab' : ''"
            class="action-text text-left p-0 m-0 ml-2 cursor-pointer"
            @click="selectedStatusDetails(7, 'N', 'Created')"
          >
            <span class="orange-dot mr-1"></span>
            Draft({{ createdCount }})
          </p>
          <p
            :class="activeStatusStyle === 'Pending' ? 'activeFilterTab' : ''"
            class="action-text text-left p-0 m-0 ml-2 cursor-pointer"
            @click="selectedStatusDetails(4, 'C', 'Pending')"
          >
            <span class="yellow-dot mr-1"></span>
            Pending({{ pendingCount }})
          </p>
          <p
            :class="activeStatusStyle === 'SentBack' ? 'activeFilterTab' : ''"
            class="action-text text-left p-0 m-0 ml-2 cursor-pointer"
            @click="selectedStatusDetails(2, 'S', 'SentBack')"
          >
            <span class="blue-dot mr-1"></span>
            SentBack({{ sendbackCount }})
          </p>
          <p
            :class="activeStatusStyle === 'Rejected' ? 'activeFilterTab' : ''"
            class="action-text text-left p-0 m-0 ml-2 cursor-pointer"
            @click="selectedStatusDetails(3, 'R', 'Rejected')"
          >
            <span class="red-dot mr-1"></span>
            Rejected({{ rejectedCount }})
          </p>
          <p
            :class="activeStatusStyle === 'all' ? 'activeFilterTab' : ''"
            class="action-text text-left p-0 m-0 ml-2 cursor-pointer"
            @click="selectedStatusDetails(0, 'all', 'all')"
          >
            <span class="black-dot mr-1"></span>
            All({{ allCount }})
          </p>
        </div>

        <div
          class="mt-5"
          v-for="(question, index) in quickLinkDetails.answer"
          :key="index"
          style="border-bottom: 1px solid #ccc"
        >
          <div class="mb-5 text-left">
            <li class="inner-title mb-3">
              {{ question.quickLinkDescription }}
            </li>
            <vueper-slides
              v-show="isAnswer"
              class="no-shadow mx-3 ml-1 mr-2"
              :visible-slides="3"
              slide-multiple
              :gap="3"
              fixed-height="300px"
              :bulletsOutside="false"
              :bullets="false"
              :slide-ratio="1 / 4"
              :dragging-distance="100"
              :breakpoints="{ 800: { visibleSlides: 2, slideMultiple: 2 } }"
            >
              <template v-slot:arrow-left>
                <img class="mx-4 slider-icon" src="@/assets/arrow_back.svg" />
              </template>

              <template v-slot:arrow-right>
                <img
                  class="mx-4 slider-icon"
                  src="@/assets/arrow_forward.svg"
                />
              </template>
              <vueper-slide
                v-for="(answerList, index1) in question.answerList"
                :key="index1"
                v-if="
                  selectedStatusFilter == 'all' ||
                  answerList.status == selectedStatusFilter
                "
              >
                <template v-slot:content>
                  <div class="card certificate-card mb-2 p-0">
                    <span class="delete-card ml-auto">
                      <button
                        class="btn-border"
                        @click="
                          editCard(
                            answerList.answer,
                            question,
                            answerList.status
                          )
                        "
                        v-if="
                          answerList.status == 'A' ||
                          answerList.status == 'N' ||
                          answerList.status == 'S'
                        "
                      >
                        <img
                          class="mr-2 mt-1 cursor-pointer"
                          src="@/assets/edit-small.png"
                          alt="icon"
                          height="13px"
                          width="13px"
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Edit"
                          animation="true"
                        />
                      </button>
                      <span v-if="answerList.status == 'N'">
                        <button
                          class="btn-border"
                          @click="
                            deleteCertificateCard(
                              answerList.answer,
                              '',
                              answerList.status
                            )
                          "
                        >
                          <img
                            class="pr-2 mt-1 cursor-pointer"
                            src="@/assets/delete-card.svg"
                            alt="icon"
                            title="Delete"
                            animation="true"
                          />
                        </button>
                      </span>
                      <!-- <span v-if="answerList.status != 'N' && answerList.status != 'A'">
                    <button
                      class="btn-border"
                      @click="trackingAnswerStatus(answerList.answer[0].id)"
                    >
                      <img
                        class="mr-2 mt-1 cursor-pointer"
                        src="@/assets/track.png"
                        alt="icon"
                        height="17px"
                        width="17px"
                        data-toggle="tooltip"
                        data-placement="top"
                        title="Tracking Status"
                        animation="true"
                      />
                    </button>
                  </span> -->
                    </span>
                    <div class="diplay-heading pl-2">Status</div>
                    <div class="row">
                      <div
                        class="col ml-0 answer-heading mb-1 ml-2"
                        v-if="answerList.status == 'A'"
                      >
                        <span
                          :class="dottedStatus(answerList.status)"
                          class="mx-1 mt-1"
                        ></span>
                        Approved
                      </div>
                      <div
                        class="col ml-0 answer-heading mb-1 ml-2"
                        v-if="answerList.status == 'N'"
                      >
                        <span
                          :class="dottedStatus(answerList.status)"
                          class="mx-1 mt-1"
                        ></span>
                        Draft
                      </div>
                      <div
                        class="col ml-0 answer-heading mb-1 ml-2"
                        v-if="answerList.status == 'C'"
                      >
                        <span
                          :class="dottedStatus(answerList.status)"
                          class="mx-1 mt-1"
                        ></span>
                        Pending
                      </div>
                      <div
                        class="col ml-0 answer-heading mb-1 ml-2"
                        v-if="answerList.status == 'R'"
                      >
                        <span
                          :class="dottedStatus(answerList.status)"
                          class="mx-1 mt-1"
                        ></span>
                        Rejected
                      </div>
                      <div
                        class="col ml-0 answer-heading mb-1 ml-2"
                        v-if="answerList.status == 'S'"
                      >
                        <span
                          :class="dottedStatus(answerList.status)"
                          class="mx-1 mt-1"
                        ></span>
                        Sent Back
                      </div>
                    </div>
                    <div
                      v-for="(answer, index2) in answerList.answer"
                      :key="index2"
                      class="pl-2 m-0"
                    >
                      <div v-if="answer.id.keyCode" class="mb-1">
                        <div class="diplay-heading">
                          {{ answer.displayName }}
                        </div>
                        <div class="ml-2 answer-heading">
                          <span v-if="answer.controlType == 'DP'">{{
                            dateFormat(answer.keyValue)
                          }}</span>
                          <span v-if="answer.controlType == 'T'">{{
                            answer.keyValue
                          }}</span>
                          <span v-if="answer.controlType == 'U'">
                            <img
                              class="mt-1 cursor-pointer"
                              src="@/assets/certificate-small.jpg"
                              alt="image"
                              height="40px"
                              width="40px"
                              data-toggle="tooltip"
                              data-placement="top"
                              title="Download Attachment"
                              animation="true"
                              @click="showAttachFile(answer.keyValue)"
                            />
                          </span>
                        </div>
                      </div>
                    </div>
                    <div>
                      <div class="pl-2 m-0">
                        <div class="diplay-heading">Remarks</div>
                        <div class="ml-2 answer-heading">
                          {{ answerList.remarks ? answerList.remarks : "-" }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <br />
                </template>
              </vueper-slide>
              <span
                v-if="generateNoRecordFoundMessage(question.answerList) != ''"
                >{{ generateNoRecordFoundMessage(question.answerList) }}</span
              >
            </vueper-slides>

            <p class="m-0 p-3 text-center" v-if="!isAnswer">
              No certificate available
            </p>
            <!-- <span v-for="(answerList,index1) in question.answerList" :key="index1">
                <div class="col">
                  <div class="card certificate-card p-0 mb-2 ml-3">
                    <span class="delete-card ml-auto">
                      <button
                        class="btn-border"
                        @click="editCard(answerList.answer,question,answerList.status)"
                      >
                        <img
                          class="mr-2 mt-1 cursor-pointer"
                          src="@/assets/edit-small.png"
                          alt="icon"
                          height="13px"
                          width="13px"
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Edit"
                          animation="true"
                        />
                      </button>
                      <span v-if="answerList.status == 'N'||answerList.status == 'C'">
                        <button
                          class="btn-border"
                          @click="deleteCertificateCard(answerList.answer,'',answerList.status)"
                        >
                          <img
                            class="pr-2 mt-1 cursor-pointer"
                            src="@/assets/delete-card.svg"
                            alt="icon"
                            title="Delete"
                            animation="true"
                          />
                        </button>
                      </span>
                    </span>
                    <div class="diplay-heading pl-2">Status</div>
                    <div class="row">
                      <div
                        class="col ml-0 answer-heading mb-1 ml-2"
                        v-if="answerList.status == 'A'"
                      >
                        <span :class="dottedStatus(answerList.status)" class="mx-1 mt-1"></span>
                        Approved
                      </div>
                      <div
                        class="col ml-0 answer-heading mb-1 ml-2"
                        v-if="answerList.status == 'N'"
                      >
                        <span :class="dottedStatus(answerList.status)" class="mx-1 mt-1"></span>
                        Created
                      </div>
                      <div
                        class="col ml-0 answer-heading mb-1 ml-2"
                        v-if="answerList.status == 'C'"
                      >
                        <span :class="dottedStatus(answerList.status)" class="mx-1 mt-1"></span>
                        Pending
                      </div>
                      <div
                        class="col ml-0 answer-heading mb-1 ml-2"
                        v-if="answerList.status == 'R'"
                      >
                        <span :class="dottedStatus(answerList.status)" class="mx-1 mt-1"></span>
                        Rejected
                      </div>
                      <div
                        class="col ml-0 answer-heading mb-1 ml-2"
                        v-if="answerList.status == 'S'"
                      >
                        <span :class="dottedStatus(answerList.status)" class="mx-1 mt-1"></span>
                        Sent Back
                      </div>
                    </div>
                    <div
                      v-for="(answer,index2) in answerList.answer"
                      :key="index2"
                      class="pl-2 m-0"
                    >
                      <div v-if="answer.id.keyCode" class="mb-1">
                        <div class="diplay-heading">{{answer.displayName}}</div>
                        <div class="ml-2 answer-heading">
                          <span v-if="answer.controlType == 'DP'">{{dateFormat(answer.keyValue)}}</span>
                          <span v-if="answer.controlType == 'T'">{{answer.keyValue}}</span>
                          <span v-if="answer.controlType == 'U'">
                            <img
                              class="mt-1 cursor-pointer"
                              src="@/assets/certificate-small.jpg"
                              alt="image"
                              height="40px"
                              width="40px"
                              data-toggle="tooltip"
                              data-placement="top"
                              title="Download Attachment"
                              animation="true"
                              @click="showAttachFile(answer.keyValue)"
                            />
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
        </span>-->
          </div>
          <div class="row">
            <div
              class="col-2 ml-3 mt-n5 cursor-pointer add-button"
              v-if="!isAddMoreDisabled"
              @click="addMore(question)"
            >
              +Add More
            </div>
            <div class="col-10"></div>
          </div>
        </div>

        <!-- Printing contact details -->
        <li class="inner-title mb-3" style="padding-top: 30px">
          Contact Details
        </li>
        <vueper-slides
          v-show="isContact"
          class="no-shadow mx-3 ml-1 mr-2"
          :visible-slides="3"
          slide-multiple
          :gap="3"
          fixed-height="300px"
          :bulletsOutside="false"
          :bullets="false"
          :slide-ratio="1 / 4"
          :dragging-distance="100"
          :breakpoints="{ 800: { visibleSlides: 2, slideMultiple: 2 } }"
        >
          <template v-slot:arrow-left>
            <img class="mx-4 slider-icon" src="@/assets/arrow_back.svg" />
          </template>

          <template v-slot:arrow-right>
            <img class="mx-4 slider-icon" src="@/assets/arrow_forward.svg" />
          </template>
          <span
            v-if="
              generateNoRecordFoundMessageContact(quickLinkDetails.contacts) !=
              ''
            "
            >{{
              generateNoRecordFoundMessageContact(quickLinkDetails.contacts)
            }}</span
          >

          <vueper-slide
            v-for="(contact, index1) in quickLinkDetails.contacts"
            :key="index1"
            v-if="
              selectedStatusFilterCode == 0 ||
              contact.status == selectedStatusFilterCode
            "
            >{{ selectedStatusFilterCode }}
            <template v-slot:content>
              <div class="card contact-card pl-2 pb-2 mb-2 ml-3">
                <span class="delete-card ml-auto">
                  <button
                    class="btn-border"
                    @click="editContactDetail(contact)"
                    v-if="
                      contact.status == 1 ||
                      contact.status == 2 ||
                      contact.status == 7
                    "
                  >
                    <img
                      class="mr-2 mt-1 cursor-pointer"
                      src="@/assets/edit-small.png"
                      alt="icon"
                      height="13px"
                      width="13px"
                      data-toggle="tooltip"
                      data-placement="top"
                      title="Edit"
                      animation="true"
                    />
                  </button>
                  <span v-if="contact.status == 7">
                    <button
                      class="btn-border"
                      @click="deleteContactCard(contact)"
                    >
                      <img
                        class="pr-2 mt-1 cursor-pointer"
                        src="@/assets/delete-card.svg"
                        alt="icon"
                        title="Delete"
                        animation="true"
                      />
                    </button>
                  </span>
                  <!-- <span v-if="contact.status != 1 && contact.status != 7">
                <button class="btn-border" @click="trackingStatus(contact)">
                  <img
                    class="mr-2 mt-1 cursor-pointer"
                    src="@/assets/track.png"
                    alt="icon"
                    height="17px"
                    width="17px"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Tracking Status"
                    animation="true"
                  />
                </button>
              </span> -->
                </span>
                <div class="diplay-heading pl-0">Status</div>
                <div class="row">
                  <div
                    class="col ml-0 answer-heading mb-0 ml-2"
                    v-if="contact.status == 1"
                  >
                    <span
                      :class="dottedStatus(contact.status)"
                      class="mx-1 mt-1"
                    ></span>
                    Approved
                  </div>
                  <div
                    class="col ml-0 answer-heading mb-0 ml-2"
                    v-if="contact.status == 7"
                  >
                    <span
                      :class="dottedStatus(contact.status)"
                      class="mx-1 mt-1"
                    ></span>
                    Draft
                  </div>
                  <div
                    class="col ml-0 answer-heading mb-0 ml-2"
                    v-if="contact.status == 4"
                  >
                    <span
                      :class="dottedStatus(contact.status)"
                      class="mx-1 mt-1"
                    ></span>
                    Pending
                  </div>
                  <div
                    class="col ml-0 answer-heading mb-0 ml-2"
                    v-if="contact.status == 3"
                  >
                    <span
                      :class="dottedStatus(contact.status)"
                      class="mx-1 mt-1"
                    ></span>
                    Rejected
                  </div>
                  <div
                    class="col ml-0 answer-heading mb-0 ml-2"
                    v-if="contact.status == 2"
                  >
                    <span
                      :class="dottedStatus(contact.status)"
                      class="mx-1 mt-1"
                    ></span>
                    Sent Back
                  </div>
                </div>
                <div class="diplay-heading">Category</div>
                <div class="ml-2 answer-heading">
                  <span v-if="contact.category == 'P'">Primary</span>
                  <span v-if="contact.category == 'S'">Secondary</span>
                </div>
                <div class="diplay-heading">Name</div>
                <div class="ml-2 answer-heading">{{ contact.name }}</div>
                <div class="diplay-heading">Designation</div>
                <div class="ml-2 answer-heading">{{ contact.designation }}</div>
                <div class="diplay-heading">Department</div>
                <div class="ml-2 answer-heading">{{ contact.department }}</div>
                <i class="fa fa-phone" aria-hidden="true"></i>
                <div class="diplay-heading">Mobile Number</div>
                <div class="ml-2 answer-heading">
                  {{ contact.mobileNumber }}
                </div>
                <div class="diplay-heading">Email</div>
                <div class="ml-2 answer-heading">{{ contact.email }}</div>
                <div class="diplay-heading">Remarks</div>
                <div class="ml-2 answer-heading">
                  {{ contact.remarks ? contact.remarks : "-" }}
                </div>
              </div>
            </template>
          </vueper-slide>
        </vueper-slides>

        <p class="m-0 p-3 text-center" v-if="quickLinkDetails.contacts == 0">
          No contacts available
        </p>

        <!-- <div class="row">
      <span v-for="(contact,index) in quickLinkDetails.contacts" :key="index">
        <div class="col">
          <div class="card contact-card pl-2 pb-2 mb-2 ml-3">
            <span class="delete-card ml-auto">
              <button class="btn-border" @click="editContactDetail(contact)">
                <img
                  class="mr-2 mt-1 cursor-pointer"
                  src="@/assets/edit-small.png"
                  alt="icon"
                  height="13px"
                  width="13px"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Edit"
                  animation="true"
                />
              </button>
              <span v-if="contact.status == 7||contact.status == 4">
                <button class="btn-border" @click="deleteContactCard(contact)">
                  <img
                    class="pr-2 mt-1 cursor-pointer"
                    src="@/assets/delete-card.svg"
                    alt="icon"
                    title="Delete"
                    animation="true"
                  />
                </button>
              </span>
            </span>
            <div class="diplay-heading pl-0">Status</div>
            <div class="row">
              <div class="col ml-0 answer-heading mb-0 ml-2" v-if="contact.status == 1">
                <span :class="dottedStatus(contact.status)" class="mx-1 mt-1"></span>
                Approved
              </div>
              <div class="col ml-0 answer-heading mb-0 ml-2" v-if="contact.status == 7">
                <span :class="dottedStatus(contact.status)" class="mx-1 mt-1"></span>
                Created
              </div>
              <div class="col ml-0 answer-heading mb-0 ml-2" v-if="contact.status == 4">
                <span :class="dottedStatus(contact.status)" class="mx-1 mt-1"></span>
                Pending
              </div>
              <div class="col ml-0 answer-heading mb-0 ml-2" v-if="contact.status == 3">
                <span :class="dottedStatus(contact.status)" class="mx-1 mt-1"></span>
                Rejected
              </div>
              <div class="col ml-0 answer-heading mb-0 ml-2" v-if="contact.status == 2">
                <span :class="dottedStatus(contact.status)" class="mx-1 mt-1"></span>
                Sent Back
              </div>
            </div>
            <div class="diplay-heading">Category</div>
            <div class="ml-2 answer-heading">
              <span v-if="contact.category=='P'">Primary</span>
              <span v-if="contact.category=='S'">Secondary</span>
            </div>
            <div class="diplay-heading">Name</div>
            <div class="ml-2 answer-heading">{{contact.name}}</div>
            <div class="diplay-heading">Designation</div>
            <div class="ml-2 answer-heading">{{contact.designation}}</div>
            <div class="diplay-heading">Department</div>
            <div class="ml-2 answer-heading">{{contact.department}}</div>
            <i class="fa fa-phone" aria-hidden="true"></i>
            <div class="diplay-heading">Mobile Number</div>
            <div class="ml-2 answer-heading">{{contact.mobileNumber}}</div>
            <div class="diplay-heading">Email</div>
            <div class="ml-2 answer-heading">{{contact.email}}</div>
          </div>
        </div>
      </span>
    </div>-->
        <div class="row">
          <div
            class="col ml-3 mt-1 cursor-pointer add-button"
            v-if="!isAddMoreDisabled"
            @click="addMoreContact()"
          >
            +Add More
          </div>
          <div class="col-10"></div>
        </div>
        <!-- <div class="row p-0 m-0 mb-2 mt-2">
      <p class="action-text text-left p-0 m-0">
        <span class="green-dot mr-1"></span> Approved
      </p>
      <p class="action-text text-left p-0 m-0 ml-2">
        <span class="orange-dot mr-1"></span> Created
      </p>
      <p class="action-text text-left p-0 m-0 ml-2">
        <span class="yellow-dot mr-1"></span> Pending
      </p>
      <p class="action-text text-left p-0 m-0 ml-2">
        <span class="blue-dot mr-1"></span>SentBack
      </p>
      <p class="action-text text-left p-0 m-0 ml-2">
        <span class="red-dot mr-1"></span>Rejected
      </p>
    </div>-->

        <!-- <b-modal
      v-model="openTrackingModal"
      class="modal-backdrop"
      ok-title="Ok"
      title="TrackingStatus"
      @ok="closeTrackingModal($event)"
      @cancel="closeTrackingModal($event)"
      :no-close-on-esc="true"
      :ok-only="true"
      size="xl"
      centered
    >
      <div class="row m-2" v-for="(data,index) in trackingDetails" :key="index">
        <div class="col-3 m-0 p-0 pl-3">
          <h4 v-if="index == 0" class="role-Name m-0 mb-2 p-0">{{roleName[0]}}</h4>
          <p v-if="data.buyer">
            <span :class="dottedTrackingStatus(data.buyer.evaluatorsActionStatus)"></span>
            <span class="popOverStatus ml-2">{{data.buyer.evaluatorsActionStatus}}</span>
            <br />
            <span class="popOverDate">{{getCreatedDate(data.buyer.insertedOn)}}</span>
            <br />
            <button
              class="popOverRemarks"
              v-b-popover.hover.bottomright="data.buyer.remarks"
            >Remarks</button>
          </p>
          <p v-else class="ml-2 p-0 m-0">
            <span :class="dottedTrackingStatus('Pending')"></span>
            <span class="ml-2">Pending</span>
          </p>
        </div>
        <div class="col-3 m-0 p-0 pl-3">
          <h4 v-if="index == 0" class="role-Name m-0 mb-2 p-0">{{roleName[1]}}</h4>
          <p v-if="data.technical">
            <span :class="dottedTrackingStatus(data.technical.evaluatorsActionStatus)"></span>
            <span class="popOverStatus ml-2">{{data.technical.evaluatorsActionStatus}}</span>
            <br />
            <span class="popOverDate">{{getCreatedDate(data.technical.insertedOn)}}</span>
            <br />
            <button
              class="popOverRemarks"
              v-b-popover.hover.bottomright="data.technical.remarks"
            >Remarks</button>
          </p>
          <span class="popOverStatus ml-2" v-else>
            <span v-if="data.buyer && data.buyer.evaluatorsActionStatus == 'Approved'">
              <span :class="dottedTrackingStatus('Pending')"></span>
              <span class="ml-2">Pending</span>
            </span>
            <span v-else>-</span>
          </span>
        </div>
        <div class="col-3 m-0 p-0 pl-3">
          <h4 v-if="index == 0" class="role-Name m-0 mb-2 p-0">{{roleName[2]}}</h4>
          <p v-if="data.commercial">
            <span :class="dottedTrackingStatus(data.commercial.evaluatorsActionStatus)"></span>
            <span class="popOverStatus ml-2">{{data.commercial.evaluatorsActionStatus}}</span>
            <br />
            <span class="popOverDate">{{getCreatedDate(data.commercial.insertedOn)}}</span>
            <br />
            <button
              class="popOverRemarks"
              v-b-popover.hover.bottomright="data.commercial.remarks"
            >Remarks</button>
          </p>
          <span class="popOverStatus ml-2" v-else>
            <span v-if="data.technical && data.technical.evaluatorsActionStatus == 'Approved'">
              <span :class="dottedTrackingStatus('Pending')"></span>
              <span class="ml-2">Pending</span>
            </span>
            <span v-else>-</span>
          </span>
        </div>
      </div>
    </b-modal> -->
      </div>
      <div
        class="business-categories"
        style="border-bottom: 1px solid #ccc; padding-top: 20px"
        v-if="techActiveFirstTab == 0"
      >
        <div
          class="col-12"
          style="
            background: #ffff9e;
            color: #ff8100;
            border-radius: 8px;
            font-weight: bold;
            padding: 5px 10px;
            margin-bottom: 10px;
            border: 1px solid red;
          "
        >
          Adding category here is not required for any business need. Kindly get
          the Empanelment done for the required categories.
        </div>
        <div class="float-right">
          <b-button class="add-pbc-button" @click="addNewBC()"
            >+ Add new Business Category</b-button
          >
          <b-button
            class="submit-pbc-approval ml-5"
            v-if="submitForApproval"
            @click="submitAllForApproval()"
            >Submit For Approval</b-button
          >
        </div>
        <div class="input-group search-bar mb-3 p-0"></div>
        <br />
        <div class="m-0 p-0">
          <p class="sub-heading-text">
            Approved Business Categories
            <img
              class="approved-gst ml-1"
              src="@/assets/Approve-tick-mark.svg"
            />
          </p>
        </div>
        <div class="card-background">
          <w-partner-table
            :tableValue="businessCategoryApprovedList"
            :tableLoading="showTableLoding"
            :filter="businessCategoryFilterText"
            :typeOfTable="'ApprovedBusinessCategoryTable'"
          />
        </div>
        <span>
          <p class="sub-heading-text mt-3 mr-3">Business Categories List</p>
          <div class="row p-0 m-0 mb-2">
            <p
              class="action-text text-left p-0 m-0 cursor-pointer"
              @click="PBCByStatusCodes(7, 'N')"
            >
              <span class="orange-dot mr-1"></span>
              Created({{ bccreatedCount }})
            </p>
            <p
              class="action-text text-left p-0 m-0 ml-2 cursor-pointer"
              @click="PBCByStatusCodes(4, 'C')"
            >
              <span class="yellow-dot mr-1"></span>
              Pending({{ bcpendingCount }})
            </p>
            <p
              class="action-text text-left p-0 m-0 ml-2 cursor-pointer"
              @click="PBCByStatusCodes(3, 'R')"
            >
              <span class="red-dot mr-1"></span>
              Rejected({{ bcrejcetedCount }})
            </p>
            <!-- <p class="action-text text-left p-0 m-0 ml-2">
          <span class="red-dot mr-1"></span>Rejected
        </p>-->
          </div>
        </span>
        <div class="card-background">
          <w-partner-table
            :tableValue="tempNotApprovedList"
            :tableLoading="showTableLoding"
            :filter="businessCategoryFilterText"
            :typeOfTable="'NotApprovedBusinessCategoryTable'"
            @submitDetailsPBC="submitSavedBCDetails($event)"
            @editDetailsPBC="editCategoryDetails($event)"
          />
        </div>

        <b-modal
          :v-if="false"
          v-model="openModal"
          centered
          :hide-header="true"
          :hide-footer="true"
          :no-close-on-backdrop="true"
          :no-close-on-esc="true"
          id="secondary-business"
          size="lg"
        >
          <p class="secondary-account-modal">
            <span v-if="!editModal" class="ml-2"
              >Add Business Category Details</span
            >
            <span v-if="editModal" class="ml-2"
              >Edit Business Category Details</span
            >
            <img
              @click="closeAddBCModal()"
              class="secondary-close cursor-pointer"
              src="@/assets/images/close1.svg"
            />
          </p>
          <div class="px-3">
            <div class="row px-2">
              <div class="col-6">
                <b-form-group
                  class="source-sans-pro bold text-left"
                  :label="'Partner Type'"
                >
                  <w-dropdown
                    class="m-0"
                    :options="partnerList"
                    @dropdownChange="getSelectedPartnerType($event)"
                    :selected="selectedPartnerType"
                    :disabled="
                      catSelectOpened == true || subCatSelectOpened == true
                    "
                  />
                </b-form-group>
              </div>
            </div>
            <div
              class="row px-2"
              :class="increaseHeight == true ? 'content-height-modal' : ''"
            >
              <div class="col-6">
                <b-form-group
                  class="source-sans-pro bold text-left"
                  :label="'Category'"
                >
                  <w-multi-select-dropdown
                    :ref="'multiselectRef'"
                    class="headings-multi-select"
                    :position="'bottom'"
                    :labelText="'Category'"
                    :disabled="!selectedPartnerType"
                    :optionFields="partnerCategory"
                    @selectedMultiselectEvent="getPartnerCategory($event)"
                    :defaultValue="bindCategoryValue(selectedCategories)"
                    @selectOpened="increaseModalHeight('Cat')"
                  />
                </b-form-group>
              </div>
              <div class="col-6">
                <b-form-group
                  class="source-sans-pro bold text-left"
                  :label="'Sub-Category'"
                >
                  <w-multi-select-dropdown
                    :ref="'multiselectRef'"
                    class="headings-multi-select"
                    :disabled="!selectedCategories.length"
                    :position="'bottom'"
                    :labelText="'Sub-Category'"
                    :optionFields="partnerSubCategory"
                    @selectedMultiselectEvent="getPartnerSubCategory($event)"
                    :defaultValue="bindSubCategoryValue(selectedSubCategories)"
                    @selectOpened="increaseModalHeight('SubCat')"
                  />
                </b-form-group>
              </div>
            </div>
            <hr class="hr-style mb-3" />
            <div class="mb-5 pb-1">
              <b-button
                v-if="!editModal"
                class="float-right mr-3 save-pbc-btn"
                @click="saveSubmitBCDetails(editModal, wantToSubmit)"
                :disabled="checkValidationBC()"
              >
                <span>Submit</span>
              </b-button>
              <b-button
                class="float-right mr-3 save-pbc-btn"
                @click="saveSubmitBCDetails(editModal, !wantToSubmit)"
                :disabled="checkValidationBC()"
              >
                <span v-if="editModal">Update</span>
                <span v-else>Save</span>
              </b-button>
              <b-button
                v-if="!editModal"
                class="float-right mr-3 save-pbc-btn"
                @click="clearBCDetails()"
              >
                <span>Clear</span>
              </b-button>
            </div>
          </div>
        </b-modal>

        <!-- <b-modal
      :v-model="false"
      id="id"
      :title="editModal? 'Edit Business Category Details':'Add Business Category Details'"
      scrollable
      size="lg"
      class="pbc-modal"
      centered="centered"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      :ok-only="true"
      :hide-footer="false"
      ok-title="Save Details"
      :ok-disabled="true"
      @close="closeAddBCModal($event)"
    >
      <template v-slot:modal-footer="{}">
        <div>
          <b-button
            v-if="!editModal"
            class="float-right mr-3 save-pbc-btn"
            @click="saveSubmitBCDetails(editModal,wantToSubmit)"
            :disabled="checkValidation()"
          >
            <span>Submit</span>
          </b-button>
          <b-button
            class="float-right mr-3 save-pbc-btn"
            @click="saveSubmitBCDetails(editModal,!wantToSubmit)"
            :disabled="checkValidation()"
          >
            <span v-if="editModal">Update</span>
            <span v-else>Save</span>
          </b-button>
          <b-button
            v-if="!editModal"
            class="float-right mr-3 save-pbc-btn"
            @click="clearBCDetails()"
          >
            <span>Clear</span>
          </b-button>
        </div>
      </template>

      <div class="row m-3">
        <div class="col-8">
          <b-form-group class="source-sans-pro bold text-left" :label="'Select Partner Type'">
            <w-dropdown
              class="m-0"
              :options="partnerList"
              @dropdownChange="getSelectedPartnerType($event)"
              :selected="selectedPartnerType"
            />
          </b-form-group>
        </div>
        <div class="col-4"></div>
      </div>
      <div class="row ml-3 mr-3">
        <div class="col-8">
          <b-form-group class="source-sans-pro bold text-left" :label="'Select Category'">
            <w-multi-select-dropdown
              :ref="'multiselectRef'"
              class="headings-multi-select"
              :disabled="!selectedPartnerType"
              :position="'bottom'"
              :labelText="'Category'"
              :optionFields="partnerCategory"
              @selectedMultiselectEvent="getPartnerCategory($event)"
              :defaultValue="bindCategoryValue(selectedCategories)"
            />
          </b-form-group>
        </div>
        <div class="col-4"></div>
      </div>
      <div class="row ml-3 mr-3">
        <div class="col-8">
          <b-form-group class="source-sans-pro bold text-left" :label="'Select Sub-Category'">
            <w-multi-select-dropdown
              :ref="'multiselectRef'"
              class="headings-multi-select"
              :disabled="!selectedCategories.length"
              :position="'bottom'"
              :labelText="'Sub-Category'"
              :optionFields="partnerSubCategory"
              @selectedMultiselectEvent="getPartnerSubCategory($event)"
              :defaultValue="bindSubCategoryValue(selectedSubCategories)"
            />
          </b-form-group>
        </div>
        <div class="col-4"></div>
      </div>
    </b-modal>-->
      </div>
    </div>
    <w-certificate
      v-if="triggerModalcert"
      :trigger="triggerModalcert"
      :text="lastResponse"
      :title="modalTitle"
      :centered="true"
      :dontCloseWhenClickedOutside="true"
      :dontCloseWhenEscapePressed="true"
      :dontShowCloseIcon="true"
      :modalbuttonStyle="true"
      :showAlert="true"
      :showSuccess="true"
      :questions="questionList"
      :description="quickLinkDescription"
      :edit="isEditClicked"
      :editAnswer="editAnswers"
      :categoryCode="currentCategoryCode"
      :docNumber="documentNumber"
      @eventClose="closeModal()"
      @afterSave="callWidget()"
    />
    <widgetModal
      :trigger="triggerModalWidget"
      :text="lastResponse"
      :title="modalTitle"
      :centered="true"
      :dontCloseWhenClickedOutside="true"
      :dontCloseWhenEscapePressed="true"
      :dontShowCloseIcon="true"
      :modalbuttonStyle="true"
      :showAlert="alertModal"
      :showSuccess="successModal"
      @eventClose="changeModalSuccess()"
    />
    <w-taxContact
      :trigger="triggerTaxContactModal"
      @eventClose="closeTaxContactModal()"
      :centered="true"
      :editContacts="editTaxContact"
      :isEdit="isEditTaxContactClicked"
      :dontCloseWhenClickedOutside="true"
      :dontCloseWhenEscapePressed="true"
      :dontShowCloseIcon="true"
      @afterSave="callWidget()"
      @alertOnSave="callAlertModal()"
    />
    <widgetModal
      :trigger="triggerModalWidgetBC"
      :text="lastResponseBC"
      :title="modalTitle"
      :centered="true"
      :dontCloseWhenClickedOutside="true"
      :dontCloseWhenEscapePressed="true"
      :dontShowCloseIcon="true"
      :modalbuttonStyle="true"
      :showAlert="alertModal"
      :showSuccess="successModal"
      @eventClose="changeModalSuccessBC()"
    />
    <w-contact
      v-if="triggerContactModal"
      :trigger="triggerContactModal"
      @eventClose="closeContactModal()"
      :dontCloseWhenClickedOutside="true"
      :dontCloseWhenEscapePressed="true"
      :dontShowCloseIcon="true"
      :editContacts="editContact"
      :isEdit="isEditContactClicked"
      :categoryCode="currentCategoryCode"
      @afterSave="callWidget()"
      @alertOnSave="callAlertModal()"
    />
    <w-address
      v-if="triggerAddressModal"
      :trigger="triggerAddressModal"
      @eventClose="closeAddressModal()"
      :dontCloseWhenClickedOutside="true"
      :dontCloseWhenEscapePressed="true"
      :dontShowCloseIcon="true"
      :editAddress="editAddress"
      :partnerId="partnerInfo.partnerId"
      :userId="partnerInfo.userId"
      :isEdit="isEditAddressClicked"
      :categoryCode="currentCategoryCode"
      @afterSave="callWidget()"
      @alertOnSave="callAddrAlertModal()"
    />
    <w-statutory
      v-if="triggerStatutoryModal"
      :trigger="triggerStatutoryModal"
      @eventClose="closeStatutoryModal()"
      :dontCloseWhenClickedOutside="true"
      :dontCloseWhenEscapePressed="true"
      :dontShowCloseIcon="true"
      :editStatutory="editStatutory"
      :partnerId="partnerInfo.partnerId"
      :userId="partnerInfo.userId"
      :currentCompanyCode="companyCode"
      :isEdit="isEditStatutoryClicked"
      :categoryCode="currentCategoryCode"
      @afterSave="callWidget()"
      @alertOnSave="callStatutoryAlertModal()"
      :isAadharApplicable="isAadharApplicable"
    />

    <w-finance
      v-if="triggerFinanceModal"
      :trigger="triggerFinanceModal"
      :dontCloseWhenClickedOutside="true"
      :dontCloseWhenEscapePressed="true"
      :dontShowCloseIcon="true"
      :isEdit="isEditFinanceClicked"
      :editFinanceDetail="editFinance"
      :categoryCode="currentCategoryCode"
      @afterSave="callWidget()"
      @eventClose="closeFinanceModal()"
    />
    <w-bank
      v-if="triggerBankModal"
      :trigger="triggerBankModal"
      :dontCloseWhenClickedOutside="true"
      :dontCloseWhenEscapePressed="true"
      :dontShowCloseIcon="true"
      :isEdit="isEditBankClicked"
      :editBankDetail="editBank"
      :categoryCode="currentCategoryCode"
      :primaryBusiness="primaryBusiness"
      @afterSave="callWidget()"
      @eventClose="closeBankModal()"
    />
    <w-confirm
      v-if="triggerConfirmModal"
      :trigger="triggerConfirmModal"
      :text="lastResponse"
      :centered="true"
      :dontCloseWhenClickedOutside="true"
      :dontCloseWhenEscapePressed="true"
      :dontShowCloseIcon="true"
      @eventOk="callAfterConfirmModal()"
      @eventCancel="closeConfirmModal()"
    />
    <w-loadingSpinner :loadSpinner="loading" />

    <!-- finance starts-->
    <div v-if="!activeFirstTab">
      <div style="text-align: left">
        <div
          class="d-inline-block"
          v-for="(data, index) in $root.isInternational
            ? interfinModTypes
            : finModTypes"
          :key="index"
        >
          <w-button-input
            :buttonText="data.text"
            :buttonStyle="fintabselectionstyle(index, data.text)"
            @onButtonClick="getFinTabData(index)"
          />
        </div>
        <b-button
          class="sumbit-approval"
          @click="ConfirmSubmitForFinApproval()"
          :disabled="gstButtonEnable"
          style="float: right; margin-bottom: 8px"
          >Submit For Financial Approval</b-button
        >
      </div>
      <div
        v-if="finActiveFirstTab == 0 && !$root.isInternational"
        style="border-top: 1px solid #ccc; margin-top: 15px; padding-top: 20px"
      >
        <div class="">
          <b-button
            class="mr-5"
            @click="addGstDetails()"
            style="
              background: #0e5d84;
              color: #fff;
              float: left;
              padding: 5px 10px;
              border-radius: 5px;
              font-weight: unset;
              width: 190px;
              text-align: center;
            "
            >+ Add more GST</b-button
          >
          <!--b-button
        class="sumbit-approval"
        @click="submitForFinancialApproval()"
        :disabled="gstButtonEnable"
      >Submit For Financial Approval</b-button-->
        </div>
        <div class="input-group search-bar mb-3 p-0">
          <div class="input-group-prepend">
            <span class="input-group-text pr-0">
              <img class="mr-2" src="@/assets/searchIcon.svg" />
            </span>
          </div>
          <input
            class="form-control border-left-0"
            placeholder="Search gst number"
            v-model="partnerDetailsFilterText"
            @keydown="clickedSearch"
            @keyup="clickedSearch"
          />
        </div>
        <div
          style="
            text-decoration: underline;
            color: blue;
            cursor: pointer;
            float: right;
          "
          @click="showGSTs()"
          v-if="false"
        >
          View Parent GSTs
        </div>
        <div
          class="m-0 p-0"
          v-if="
            gstTableDataList.items != null && gstTableDataList.items.length > 0
          "
        >
          <p
            class="sub-heading-text"
            style="padding-bottom: 5px; margin-bottom: 0px; font-size: 15px"
          >
            Approved GST List
            <img
              class="approved-gst ml-1"
              src="@/assets/Approve-tick-mark.svg"
            />
          </p>
        </div>
        <div
          class="card-background"
          v-if="
            gstTableDataList.items != null && gstTableDataList.items.length > 0
          "
        >
          <w-collapse-table
            :tableProperties="gstTableDataList"
            :tableLoading="showTableLoding"
            :filter="partnerDetailsFilterText"
            :typeOfTable="'ApprovedgstTable'"
            @getPoNumber="goToPoWoDetails($event)"
            @openGstModal="triggerApprovedEditGstModal($event)"
          />
        </div>
        <span>
          <p class="sub-heading-text mt-3 mr-3">Remaining GST List</p>
          <div
            class="row p-0 m-0 mb-2"
            v-if="
              gstPendingTableDataList.items.length > 0 ||
              tempGstPendingDetails.length > 0
            "
          >
            <p
              class="action-text text-left p-0 m-0 cursor-pointer"
              @click="GstByStatus(7, 'N')"
            >
              <span class="orange-dot mr-1"></span>
              Created({{ gstcreatedCount }})
            </p>
            <p
              class="action-text text-left p-0 m-0 ml-2 cursor-pointer"
              @click="GstByStatus(4, 'C')"
            >
              <span class="yellow-dot mr-1"></span>
              Pending({{ gstpendingCount }})
            </p>
            <p
              class="action-text text-left p-0 m-0 ml-2 cursor-pointer"
              @click="GstByStatus(2, 'S')"
            >
              <span class="blue-dot mr-1"></span>
              SentBack({{ gstsentbackCount }})
            </p>
            <p
              class="action-text text-left p-0 m-0 ml-2 cursor-pointer"
              @click="GstByStatus(3, 'R')"
            >
              <span class="red-dot mr-1"></span>
              Rejected({{ gstrejectedCount }})
            </p>
          </div>
        </span>
        <div class="card-background">
          <w-collapse-table
            :tableProperties="gstPendingTableDataList"
            :tableLoading="showTableLoding"
            :filter="partnerDetailsFilterText"
            :typeOfTable="'gstTable'"
            @getPoNumber="goToPoWoDetails($event)"
            @openGstModal="triggerEditGstModal($event)"
          />
        </div>
      </div>
      <div
        v-if="
          (finActiveFirstTab == 1 && $root.isInternational) ||
          (finActiveFirstTab == 2 && !$root.isInternational)
        "
      >
        <div style="font-weight: bold; text-align: left; margin-top: 10px">
          Approved Statutory Details
        </div>
        <div class="pb-3">
          <div
            class="table-wrapper-scroll-y my-custom-scrollbar table-responsive"
          >
            <table class="table table-striped mb-0">
              <thead>
                <tr>
                  <th scope="col">Status</th>
                  <th scope="col">Action</th>
                  <th scope="col" v-if="!$root.isInternational">TAN Number</th>
                  <th scope="col" v-if="!$root.isInternational">
                    TAN Dcoument
                  </th>

                  <th scope="col" v-if="!$root.isInternational">Is MSME</th>
                  <th scope="col" v-if="!$root.isInternational">MSME Number</th>
                  <th scope="col" v-if="!$root.isInternational">
                    MSME Document
                  </th>
                  <th scope="col" v-if="!$root.isInternational">MSME Type</th>
                  <th scope="col" v-if="!$root.isInternational">
                    MSME Effective From
                  </th>
                  <th scope="col" v-if="!$root.isInternational">
                    MSME Classification Year
                  </th>
                  <th scope="col" v-if="$root.isInternational">VAT Number</th>
                  <th scope="col" v-if="$root.isInternational">VAT Document</th>
                  <th
                    scope="col"
                    v-if="!$root.isInternational && isAadharApplicable"
                  >
                    Aadhaar Number
                  </th>
                  <th
                    scope="col"
                    v-if="!$root.isInternational && isAadharApplicable"
                  >
                    Aadhaar Document
                  </th>
                </tr>
              </thead>
              <tbody class="text-left">
                <tr>
                  <td scope="col" style="min-width: 95px">
                    <span :class="getStatus(1)"> </span> {{ getStatus(1) }}
                  </td>
                  <td scope="col" style="min-width: 75px">
                    <span>
                      <button
                        class="btn-border"
                        @click="editApprovedStatutoryDetails(statutoryDetails)"
                      >
                        Edit
                        <img
                          class="mr-2 mt-1 cursor-pointer"
                          src="@/assets/edit-small.png"
                          alt="icon"
                          height="13px"
                          width="13px"
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Edit"
                          animation="true"
                        />
                      </button>
                    </span>
                  </td>
                  <td scope="col" v-if="!$root.isInternational">
                    {{ statutoryDetails.tanNumber }}
                  </td>

                  <td scope="col" v-if="!$root.isInternational">
                    <a
                      v-if="statutoryDetails.tanDocumentId != null"
                      @click="showAttachFile(statutoryDetails.tanDocumentId)"
                      href="#"
                      >{{ getFileName(statutoryDetails.tanDocumentId) }}</a
                    >
                    <span v-else>{{
                      getFileName(statutoryDetails.tanDocumentId)
                    }}</span>
                  </td>

                  <td scope="col" v-if="!$root.isInternational">
                    {{
                      statutoryDetails.isMsme == "N"
                        ? "No"
                        : statutoryDetails.isMsme == "Y"
                        ? "Yes"
                        : ""
                    }}
                  </td>
                  <td scope="col" v-if="!$root.isInternational">
                    {{ statutoryDetails.msmedNumber }}
                  </td>
                  <td scope="col" v-if="!$root.isInternational">
                    <a
                      v-if="statutoryDetails.msmeDocId != null"
                      @click="showAttachFile(statutoryDetails.msmeDocId)"
                      href="#"
                      >{{ getFileName(statutoryDetails.msmeDocId) }}</a
                    >
                    <span v-else>{{
                      getFileName(statutoryDetails.msmeDocId)
                    }}</span>
                  </td>
                  <td scope="col" v-if="!$root.isInternational">
                    {{ statutoryDetails.msmeType }}
                  </td>
                  <td scope="col" v-if="!$root.isInternational">
                    {{ statutoryDetails.certificateEffectiveFrom }}
                  </td>
                  <td scope="col" v-if="!$root.isInternational">
                    {{ statutoryDetails.msmeClassificationYear }}
                  </td>
                  <td scope="col" v-if="$root.isInternational">
                    {{ statutoryDetails.vatNumber }}
                  </td>
                  <td scope="col" v-if="$root.isInternational">
                    <a
                      v-if="statutoryDetails.vatDocumentId != null"
                      @click="showAttachFile(statutoryDetails.vatDocumentId)"
                      href="#"
                      >{{ getFileName(statutoryDetails.vatDocumentId) }}</a
                    >
                    <span v-else>{{
                      getFileName(statutoryDetails.vatDocumentId)
                    }}</span>
                  </td>
                  <td
                    scope="col"
                    v-if="!$root.isInternational && isAadharApplicable"
                  >
                    {{ statutoryDetails.aadhaarNumber }}
                  </td>
                  <td
                    scope="col"
                    v-if="!$root.isInternational && isAadharApplicable"
                  >
                    <a
                      v-if="statutoryDetails.aadhaarDocumentId != null"
                      @click="
                        showAttachFile(statutoryDetails.aadhaarDocumentId)
                      "
                      href="#"
                      >{{ getFileName(statutoryDetails.aadhaarDocumentId) }}</a
                    >
                    <span v-else>{{
                      getFileName(statutoryDetails.aadhaarDocumentId)
                    }}</span>
                  </td>
                </tr>
                <tr v-if="statutoryDetails.length == 0">
                  <td colspan="11" class="m-0 p-0">
                    <div class="m-0 p-3 text-center">
                      No Statutory details available
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        
        <div v-if="enableKycAcceptDiv">
          <div
          v-if="showKycAcceptDiv"
          style="
            padding: 0px 25px;
            font-weight: bold;
            text-align: center;
            width: 70%;
            margin: auto;
            margin-bottom: 10px;
          "
        >
          <input
            type="checkbox"
            v-model="isChecked"
            
            style="
              width: 18px;
              height: 18px;
              margin-right: 10px;
              vertical-align: text-bottom;
              font-size: 16px;
              outline: 2px solid #c3c3c3;
              cursor: pointer;
            "
          />
          <span
            @click="isChecked = !isChecked"
            style="font-size: 16px; user-select: none; cursor: pointer"
          >
            Accept no change in MSME.
          </span>
          <button
            class="btn btn-primary btn-sm submit-button ml-3"
            @click="handleButtonClick"
            :disabled="!isChecked"
          >
            Submit Acceptance
          </button>
        </div>
        <div
          v-if="!showKycAcceptDiv"
          style="
            font-size: 16px;
            padding: 0px 25px;
            font-weight: bold;
            text-align: center;
            width: 70%;
            margin: auto;
            margin-bottom: 10px;
          "
        >
          KYC Accepted on {{ this.kycAcceptedDate }}.
        </div>
        </div>
        
        
        <div style="font-weight: bold; text-align: left">
          Pipeline Statutory Details
        </div>
        <div class="pb-3">
          <div
            class="table-wrapper-scroll-y my-custom-scrollbar table-responsive"
          >
            <table class="table table-striped mb-0">
              <thead>
                <tr>
                  <th scope="col">Status</th>
                  <th scope="col">Action</th>
                  <th scope="col">Document Number</th>
                  <th scope="col" v-if="!$root.isInternational">TAN Number</th>
                  <th scope="col" v-if="!$root.isInternational">
                    TAN Dcoument
                  </th>
                  <th scope="col" v-if="!$root.isInternational">Is MSME</th>
                  <th scope="col" v-if="!$root.isInternational">MSME Number</th>
                  <th scope="col" v-if="!$root.isInternational">
                    MSME Document
                  </th>
                  <th scope="col" v-if="!$root.isInternational">MSME Type</th>
                  <th scope="col" v-if="!$root.isInternational">
                    MSME Effective From
                  </th>
                  <th scope="col" v-if="!$root.isInternational">
                    MSME Classification Year
                  </th>
                  <th scope="col" v-if="$root.isInternational">VAT Number</th>
                  <th scope="col" v-if="$root.isInternational">VAT Document</th>
                  <th
                    scope="col"
                    v-if="!$root.isInternational && isAadharApplicable"
                  >
                    Aadhaar Number
                  </th>
                  <th
                    scope="col"
                    v-if="!$root.isInternational && isAadharApplicable"
                  >
                    Aadhaar Document
                  </th>
                </tr>
              </thead>
              <tbody class="text-left">
                <tr
                  v-for="(statutory, index) in statutoryQLDetails"
                  :key="index"
                >
                  <td scope="col" style="min-width: 95px">
                    <span :class="getStatus(statutory.statusCode)"> </span>
                    {{ getStatus(statutory.statusCode) }}
                  </td>
                  <td scope="col" style="min-width: 75px">
                    <span
                      v-if="
                        statutory.statusCode == 7 ||
                        statutory.statusCode == 1 ||
                        statutory.statusCode == 2
                      "
                    >
                      <button
                        class="btn-border"
                        @click="editStatutoryQLDetails(statutory)"
                      >
                        Edit
                        <img
                          class="mr-2 mt-1 cursor-pointer"
                          src="@/assets/edit-small.png"
                          alt="icon"
                          height="13px"
                          width="13px"
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Edit"
                          animation="true"
                        />
                      </button>
                    </span>
                  </td>
                  <td scope="col">{{ statutory.id.documentNumber }}</td>
                  <td scope="col" v-if="!$root.isInternational">
                    {{ statutory.tanNumber }}
                  </td>

                  <td scope="col" v-if="!$root.isInternational">
                    <a
                      v-if="statutory.tanDocumentId != null"
                      @click="showAttachFile(statutory.tanDocumentId)"
                      href="#"
                      >{{ getFileName(statutory.tanDocumentId) }}</a
                    >
                    <span v-else>{{
                      getFileName(statutory.tanDocumentId)
                    }}</span>
                  </td>
                  <td scope="col" v-if="!$root.isInternational">
                    {{
                      statutory.isMsme == "N"
                        ? "No"
                        : statutory.isMsme == "Y"
                        ? "Yes"
                        : ""
                    }}
                  </td>
                  <td scope="col" v-if="!$root.isInternational">
                    {{ statutory.msmedNumber }}
                  </td>
                  <td scope="col" v-if="!$root.isInternational">
                    <a
                      v-if="statutory.msmeDocId != null"
                      @click="showAttachFile(statutory.msmeDocId)"
                      href="#"
                      >{{ getFileName(statutory.msmeDocId) }}</a
                    >
                    <span v-else>{{ getFileName(statutory.msmeDocId) }}</span>
                  </td>
                  <td scope="col" v-if="!$root.isInternational">
                    {{ statutory.msmeType }}
                  </td>
                  <td scope="col" v-if="!$root.isInternational">
                    {{ statutory.certificateEffectiveFrom }}
                  </td>
                  <td scope="col" v-if="!$root.isInternational">
                    {{ statutory.msmeClassificationYear }}
                  </td>
                  <td scope="col" v-if="$root.isInternational">
                    {{ statutory.vatNumber }}
                  </td>
                  <td scope="col" v-if="$root.isInternational">
                    <a
                      v-if="statutory.vatDocumentId != null"
                      @click="showAttachFile(statutory.vatDocumentId)"
                      href="#"
                      >{{ getFileName(statutory.vatDocumentId) }}</a
                    >
                    <span v-else>{{
                      getFileName(statutory.vatDocumentId)
                    }}</span>
                  </td>
                  <td
                    scope="col"
                    v-if="!$root.isInternational && isAadharApplicable"
                  >
                    {{ statutory.aadhaarNumber }}
                  </td>
                  <td
                    scope="col"
                    v-if="!$root.isInternational && isAadharApplicable"
                  >
                    <a
                      v-if="statutory.aadhaarDocumentId != null"
                      @click="showAttachFile(statutory.aadhaarDocumentId)"
                      href="#"
                      >{{ getFileName(statutory.aadhaarDocumentId) }}</a
                    >
                    <span v-else>{{
                      getFileName(statutory.aadhaarDocumentId)
                    }}</span>
                  </td>
                </tr>
                <tr v-if="statutoryQLDetails.length == 0">
                  <td colspan="11" class="m-0 p-0">
                    <div class="m-0 p-3 text-center">
                      No Statutory details available
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div v-if="finActiveFirstTab == 3">
        <!-- Printing financial performance -->
        <li
          class="inner-title mb-3 mt-3"
          style="padding-top: 20px; border-top: 1px solid #ccc"
        >
          Financial Performance

          <!--b-button
        class="sumbit-approval"
        @click="submitForFinancialApproval()"
        :disabled="gstButtonEnable" style="float: right;margin-bottom: 8px;"
      >Submit For Financial Approval</b-button-->
        </li>
        <div>
          <div class="pb-3">
            <div
              class="table-wrapper-scroll-y my-custom-scrollbar table-responsive"
            >
              <table class="table table-striped mb-0">
                <thead>
                  <tr>
                    <th scope="col">Status</th>
                    <th scope="col">Financial Year</th>
                    <th scope="col">Assets</th>
                    <th scope="col">Gross Profit</th>
                    <th scope="col">Net Profit</th>
                    <th scope="col">RoA</th>
                    <th scope="col">RoCE</th>
                    <th scope="col">Turnover</th>
                    <th scope="col">Remarks</th>
                    <th scope="col">Attachment</th>
                    <th scope="col" style="width: 75px">Action</th>
                  </tr>
                </thead>
                <tbody class="text-left">
                  <tr
                    v-for="(finance, index) in quickLinkDetails.financeDetails"
                    :key="index"
                  >
                    <td scope="col" style="min-width: 95px">
                      <span :class="getStatus(finance.statusCode)"></span>
                      {{ getStatus(finance.statusCode) }}
                    </td>
                    <td scope="col" style="width: 120px">
                      <!-- <div class="col ml-0 answer-heading mb-0" v-if="finance.statusCode == 1"> -->
                      <span
                        :class="dottedStatus(finance.statusCode)"
                        class="mx-1 mt-1"
                      ></span>
                      <!-- </div> -->
                      <!-- <div class="col ml-0 answer-heading mb-0" v-if="finance.statusCode == 7">
                    <span :class="dottedStatus(finance.statusCode)" class="mx-1 mt-1"></span>
                  </div>
                  <div class="col ml-0 answer-heading mb-0" v-if="finance.statusCode == 4">
                    <span :class="dottedStatus(finance.statusCode)" class="mx-1 mt-1"></span>
                  </div>
                  <div class="col ml-0 answer-heading mb-0" v-if="finance.statusCode == 3">
                    <span :class="dottedStatus(finance.statusCode)" class="mx-1 mt-1"></span>
                  </div>
                  <div class="col ml-0 answer-heading mb-0" v-if="finance.statusCode == 2">
                    <span :class="dottedStatus(finance.statusCode)" class="mx-1 mt-1"></span>
                  </div>-->
                      {{ finance.financeYear }}-{{ finance.financeYear + 1 }}
                    </td>
                    <td scope="col">{{ finance.assetValue }}</td>
                    <td scope="col">{{ finance.grossProfit }}</td>
                    <td scope="col">{{ finance.netProfit }}</td>
                    <td scope="col">{{ finance.roa }}</td>
                    <td scope="col">{{ finance.roce }}</td>
                    <td scope="col">{{ finance.turnover }}</td>
                    <td scope="col">
                      {{ finance.remarks ? finance.remarks : "-" }}
                    </td>
                    <td scope="col">
                      <a
                        v-if="finance.financialAttachment != null"
                        @click="showAttachFile(finance.financialAttachment)"
                        href="#"
                        >{{ getFileName(finance.financialAttachment) }}</a
                      >
                      <span v-else>{{
                        getFileName(finance.financialAttachment)
                      }}</span>
                    </td>
                    <td scope="col" style="min-width: 75px">
                      <span
                        v-if="
                          finance.statusCode == 7 ||
                          finance.statusCode == 1 ||
                          finance.statusCode == 2
                        "
                      >
                        <button class="btn-border">
                          <img
                            class="mr-2 mt-1 cursor-pointer"
                            src="@/assets/edit-small.png"
                            alt="icon"
                            height="13px"
                            width="13px"
                            data-toggle="tooltip"
                            data-placement="top"
                            title="Edit"
                            animation="true"
                            @click="editFinanceDetails(finance)"
                          />
                        </button>
                      </span>
                      <span v-if="finance.statusCode == 7">
                        <button class="btn-border">
                          <img
                            class="pr-2 mt-1 cursor-pointer"
                            width="32px"
                            src="@/assets/delete_Icon.svg"
                            alt="icon"
                            title="Delete"
                            animation="true"
                            @click="deleteFinanceDetail(finance)"
                          />
                        </button>
                      </span>
                      <span v-if="false" style="display: none">
                        <button
                          class="btn-border"
                          @click="trackingStatus(finance)"
                        >
                          <img
                            class="mr-2 mt-1 cursor-pointer"
                            src="@/assets/track.png"
                            alt="icon"
                            height="17px"
                            width="17px"
                            data-toggle="tooltip"
                            data-placement="top"
                            title="Tracking Status"
                            animation="true"
                          />
                        </button>
                      </span>
                    </td>
                  </tr>
                  <tr v-if="quickLinkDetails.financeDetails == 0">
                    <td colspan="11" class="m-0 p-0">
                      <div class="m-0 p-3 text-center">
                        No finance records available
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="">
          <div
            class="col ml-3 mt-1 cursor-pointer add-button"
            v-if="!isAddMoreDisabled"
            @click="addMoreFinanceDetails()"
            style="
              background: #0e5d84;
              color: #fff;
              padding: 5px 10px;
              border-radius: 5px;
              font-weight: unset;
              width: 190px;
              text-align: center;
            "
          >
            + Add More Financial Details
          </div>
        </div>
      </div>
      <div
        v-if="
          (finActiveFirstTab == 1 &&
            primaryBusiness.categoryCode != currentCategoryCode &&
            !$root.isInternational) ||
          (finActiveFirstTab == 0 &&
            primaryBusiness.categoryCode != currentCategoryCode &&
            $root.isInternational)
        "
        style="
          width: 100%;
          background: #f4f47f;
          font-weight: bold;
          color: #ab1818;
          text-align: left;
          margin: 10px 0px;
          padding: 10px;
        "
      >
        Attention: Please note that Bank details in Primary business category
        only taken into account. So please switch to
        {{ primaryBusiness.categoryName }} profile to check or edit your bank
        details.
      </div>
      <div
        v-if="
          (finActiveFirstTab == 1 &&
            primaryBusiness.categoryCode == currentCategoryCode &&
            !$root.isInternational) ||
          (finActiveFirstTab == 0 &&
            primaryBusiness.categoryCode == currentCategoryCode &&
            $root.isInternational)
        "
        :class="
          primaryBusiness.categoryCode != currentCategoryCode ? 'disabled' : ''
        "
      >
        <!-- Printing bank details -->
        <li
          class="inner-title mb-3 mt-3"
          style="padding-top: 20px; border-top: 1px solid #ccc"
        >
          Bank Details
          <!--b-button
        class="sumbit-approval"
        @click="submitForFinancialApproval()"
        :disabled="gstButtonEnable" style="float: right;margin-bottom: 8px;"
      >Submit For Financial Approval</b-button-->
        </li>
        <div
          class="table-wrapper-scroll-y my-custom-scrollbar table-responsive"
        >
          <table class="table table-striped mb-0">
            <thead>
              <tr>
                <th scope="col">Status</th>
                <th
                  scope="col"
                  v-if="primaryBusiness.categoryCode == currentCategoryCode"
                >
                  Action
                </th>
                <th scope="col">Account Category</th>
                <th scope="col">Account Number</th>
                <th scope="col">Payment in favour of</th>
                <th scope="col">Account Type</th>
                <th scope="col">Payment Mode</th>
                <th scope="col">Bank Name</th>
                <th scope="col" v-if="!$root.isInternational">IFSC Code</th>
                <th scope="col" v-if="$root.isInternational">Swift Code</th>
                <th scope="col" v-if="$root.isInternational">IBAN Number</th>
                <th scope="col" v-if="$root.isInternational">Sort Code</th>
                <th scope="col">Remarks</th>
                <th scope="col">Attachment</th>
                <th scope="col">Reference Number</th>
                <th scope="col">Payment Ref Email</th>
              </tr>
            </thead>
            <tbody class="text-left table-body">
              <tr
                v-for="(bankAccount, index) in quickLinkDetails.bankDetails"
                :key="index"
              >
                <td scope="col" style="min-width: 110px">
                  <span
                    :class="
                      getStatusv(
                        bankAccount.statusCode,
                        bankAccount.updatedBy,
                        bankAccount.updatedByCommunityCode
                      )
                    "
                  ></span>
                  <span>
                    {{
                      getStatusv(
                        bankAccount.statusCode,
                        bankAccount.updatedBy,
                        bankAccount.updatedByCommunityCode
                      )
                    }}
                  </span>
                  <span style="font-size: 12px; color: #555">
                    {{
                      getStatusv(
                        bankAccount.statusCode,
                        bankAccount.updatedBy,
                        bankAccount.updatedByCommunityCode
                      ) == "Not-Certified"
                        ? "Kindly Edit and submit for approval"
                        : ""
                    }}</span
                  >
                </td>
                <td
                  scope="col"
                  style="min-width: 100px"
                  v-if="primaryBusiness.categoryCode == currentCategoryCode"
                >
                  <span
                    v-if="
                      bankAccount.statusCode == 7 ||
                      bankAccount.statusCode == 1 ||
                      bankAccount.statusCode == 2
                    "
                  >
                    <button
                      class="btn-border"
                      @click="editBankDetails(bankAccount)"
                    >
                      Edit
                      <img
                        class="mr-2 mt-1 cursor-pointer"
                        src="@/assets/edit-small.png"
                        alt="icon"
                        height="10px"
                        width="10px"
                        data-toggle="tooltip"
                        data-placement="top"
                        title="Edit"
                        animation="true"
                        style="margin: 0px !important"
                      />
                    </button>
                  </span>
                  <span
                    v-if="
                      bankAccount.statusCode == 7 ||
                      bankAccount.accountCategory == 'Secondary' ||
                      bankAccount.statusCode == 3 ||
                      bankAccount.statusCode == 2
                    "
                  >
                    <button class="btn-border">
                      Delete
                      <img
                        class="pr-2 mt-1 cursor-pointer"
                        src="@/assets/delete_Icon.svg"
                        alt="icon"
                        title="Delete"
                        animation="true"
                        height="19px"
                        width="19px"
                        @click="deleteBankDetail(bankAccount)"
                        style="margin: 0px !important; padding: 0px !important"
                      />
                    </button>
                  </span>
                  <!-- <span v-if="bankAccount.statusCode != 1 && bankAccount.statusCode != 7">
                <button class="btn-border" @click="trackingStatus(bankAccount)">
                  <img
                    class="mr-2 mt-1 cursor-pointer"
                    src="@/assets/track.png"
                    alt="icon"
                    height="17px"
                    width="17px"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Tracking Status"
                    animation="true"
                  />
                </button>
              </span> -->
                </td>
                <td scope="col" style="width: 120px">
                  <span
                    :class="dottedStatus(bankAccount.statusCode)"
                    class="mx-1 mt-1"
                  ></span>
                  <!-- <div class="col ml-0 answer-heading mb-0" v-if="bankAccount.statusCode == 1">
                <span :class="dottedStatus('A')" class="mx-1 mt-1"></span>
              </div>
              <div class="col ml-0 answer-heading mb-0" v-if="bankAccount.statusCode == 7">
                <span :class="dottedStatus('N')" class="mx-1 mt-1"></span>
              </div>
              <div class="col ml-0 answer-heading mb-0" v-if="bankAccount.statusCode == 4">
                <span :class="dottedStatus('C')" class="mx-1 mt-1"></span>
              </div>
              <div class="col ml-0 answer-heading mb-0" v-if="bankAccount.statusCode == 3">
                <span :class="dottedStatus('R')" class="mx-1 mt-1"></span>
              </div>
              <div class="col ml-0 answer-heading mb-0" v-if="bankAccount.statusCode == 2">
                <span :class="dottedStatus('S')" class="mx-1 mt-1"></span>
              </div>-->
                  {{ bankAccount.accountCategory }}
                </td>
                <td scope="col">{{ bankAccount.accountNumber }}</td>
                <td scope="col">{{ bankAccount.paymentInfavourOf }}</td>
                <td scope="col">{{ bankAccount.accountType }}</td>
                <td scope="col">{{ bankAccount.paymentMode }}</td>
                <td scope="col">{{ bankAccount.bankName }}</td>
                <td scope="col" v-if="!$root.isInternational">
                  {{ bankAccount.ifscCode }}
                </td>
                <td scope="col" v-if="$root.isInternational">
                  {{ bankAccount.swiftBicCode }}
                </td>
                <td scope="col" v-if="$root.isInternational">
                  {{ bankAccount.ibanNumber }}
                </td>
                <td scope="col" v-if="$root.isInternational">
                  {{ bankAccount.sortCode }}
                </td>
                <td scope="col">
                  {{ bankAccount.remarks ? bankAccount.remarks : "-" }}
                </td>

                <td scope="col">
                  <a
                    v-if="bankAccount.documentId != null"
                    @click="showAttachFile(bankAccount.documentId)"
                    href="#"
                    >{{ getFileName(bankAccount.documentId) }}</a
                  >
                  <span v-else>-</span>
                </td>
                <td>{{ bankAccount.documentNo }}</td>
                <td>{{ bankAccount.paymentRefMailId }}</td>
              </tr>
              <tr v-if="quickLinkDetails.bankDetails == 0">
                <td colspan="11" class="m-0 p-0">
                  <div class="m-0 p-3 text-center">
                    No bank records available
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div
          class=""
          v-if="primaryBusiness.categoryCode == currentCategoryCode"
        >
          <div
            class="col ml-3 mt-1 cursor-pointer add-button"
            v-if="!isAddMoreDisabled"
            @click="addMoreBankDetails()"
            style="
              background: #0e5d84;
              color: #fff;
              padding: 5px 10px;
              border-radius: 5px;
              font-weight: unset;
              width: 190px;
              text-align: center;
            "
          >
            + Add More Bank Details
          </div>
        </div>
      </div>

      <!--div v-if="finActiveFirstTab == 1 && primaryBusiness.categoryCode!=currentCategoryCode"
    style="width: 100%;background: #f4f47f;font-weight: bold;color: #ab1818;text-align: left;
    margin: 10px 0px;padding: 10px;">
    Attention: Please note that Bank details in Primary business category only taken into account. So please switch to {{primaryBusiness.categoryName}} profile to check or edit your bank details.
      </div-->
      <!-- <b-modal
      v-model="openTrackingModal"
      class="modal-backdrop"
      ok-title="Ok"
      title="TrackingStatus"
      @ok="closeTrackingModal($event)"
      @cancel="closeTrackingModal($event)"
      :no-close-on-esc="true"
      :ok-only="true"
      size="xl"
      centered
    >
      <div class="row m-2" v-for="(data,index) in trackingDetails" :key="index">
        <div class="col-3 m-0 p-0 pl-3">
          <h4 v-if="index == 0" class="role-Name m-0 mb-2 p-0">{{roleName[0]}}</h4>
          <p v-if="data.buyer">
            <span :class="dottedStatus(data.buyer.evaluatorsActionStatus)"></span>
            <span class="popOverStatus ml-2">{{data.buyer.evaluatorsActionStatus}}</span>
            <br />
            <span class="popOverDate">{{getCreatedDate(data.buyer.insertedOn)}}</span>
            <br />
            <button
              class="popOverRemarks"
              v-b-popover.hover.bottomright="data.buyer.remarks"
            >Remarks</button>
          </p>
          <p v-else class="ml-2 p-0 m-0">
            <span :class="dottedStatus('Pending')"></span>
            <span class="ml-2">Pending</span>
          </p>
        </div>
        <div class="col-3 m-0 p-0 pl-3">
          <h4 v-if="index == 0" class="role-Name m-0 mb-2 p-0">{{roleName[1]}}</h4>
          <p v-if="data.technical">
            <span :class="dottedStatus(data.technical.evaluatorsActionStatus)"></span>
            <span class="popOverStatus ml-2">{{data.technical.evaluatorsActionStatus}}</span>
            <br />
            <span class="popOverDate">{{getCreatedDate(data.technical.insertedOn)}}</span>
            <br />
            <button
              class="popOverRemarks"
              v-b-popover.hover.bottomright="data.technical.remarks"
            >Remarks</button>
          </p>
          <span class="popOverStatus ml-2" v-else>
            <span v-if="data.buyer && data.buyer.evaluatorsActionStatus == 'Approved'">
              <span :class="dottedStatus('Pending')"></span>
              <span class="ml-2">Pending</span>
            </span>
            <span v-else>-</span>
          </span>
        </div>
        <div class="col-3 m-0 p-0 pl-3">
          <h4 v-if="index == 0" class="role-Name m-0 mb-2 p-0">{{roleName[2]}}</h4>
          <p v-if="data.commercial">
            <span :class="dottedStatus(data.commercial.evaluatorsActionStatus)"></span>
            <span class="popOverStatus ml-2">{{data.commercial.evaluatorsActionStatus}}</span>
            <br />
            <span class="popOverDate">{{getCreatedDate(data.commercial.insertedOn)}}</span>
            <br />
            <button
              class="popOverRemarks"
              v-b-popover.hover.bottomright="data.commercial.remarks"
            >Remarks</button>
          </p>
          <span class="popOverStatus ml-2" v-else>
            <span v-if="data.technical && data.technical.evaluatorsActionStatus == 'Approved'">
              <span :class="dottedStatus('Pending')"></span>
              <span class="ml-2">Pending</span>
            </span>
            <span v-else>-</span>
          </span>
        </div>
      </div>
    </b-modal>-->
      <b-modal
        v-model="openModal"
        id="id"
        :title="editModal ? 'Edit Gst Details' : 'Register GST Details'"
        scrollable
        size="lg"
        class="gst-modal"
        @ok="saveGstDetails($event)"
        @cancel="eventCancel($event)"
        centered="centered"
        :no-close-on-backdrop="true"
        :no-close-on-esc="true"
        :ok-only="true"
        :hide-footer="false"
        ok-title="Save Gst Details"
        :ok-disabled="enableSubmit"
      >
        <template v-slot:modal-footer="{}">
          <div>
            <b-button
              class="float-right mr-3 save-gst-button"
              @click="saveGstDetails(editModal, approvedEditList)"
              :disabled="checkValidation()"
            >
              <span v-if="editModal">Update GST Details</span>
              <span v-else>Save GST Details</span>
            </b-button>
          </div>
        </template>
        <!-- :hide-header-close="true"
      :hide-footer="true"
      :hide-header="true"-->
        <div>
          <!-- <div class="empanel-modal-close">
          <span class="Modal-head-text">Register Gst</span>
          <p class>
            <img
              @click="closeModal()"
              class="cursor-pointer modal-close-button mt-n1"
              style="float:right"
              src="@/assets/images/close1.svg"
            />
          </p>
        </div>-->
          <div>
            <b-alert
              :show="dismissCountDown"
              dismissible
              variant="danger"
              @dismissed="dismissCountDown = 0"
              @dismiss-count-down="countDownChanged"
            >
              <p class="m-0 p-0 alertText">{{ errorMessage }}</p>
            </b-alert>
            <div class="row">
              <div class="col-4">
                <p class="m-0 p-0 pt-1 pl-2 partner-reg">Partner Reg no.</p>
                <p class="m-0 p-0 pl-2 partner-reg-subText">
                  {{ partnerDetailInfo.partnerNumber }}
                </p>
              </div>
              <div class="col-4">
                <p class="m-0 p-0 pt-1 partner-reg">Vendor name</p>
                <p class="m-0 p-0 partner-reg-subText">
                  {{ partnerDetailInfo.organizationName }}
                </p>
              </div>
              <div class="col-4">
                <p class="m-0 p-0 pt-1 partner-reg">GST country</p>
                <p
                  class="m-0 p-0 partner-reg-subText"
                  v-if="
                    partnerDetailInfo.countryDetail &&
                    partnerDetailInfo.countryDetail.longDesc
                  "
                >
                  {{ partnerDetailInfo.countryDetail.longDesc }}
                </p>
              </div>
            </div>
            <div class="col-10 mt-3 ml-1">
              <p class="m-0 p-0 pt-1 partner-reg">GST State</p>
              <w-drop-down
                class="width-control-small"
                :options="gststatelist"
                @dropdownChange="getResgisteredGstState($event)"
                :selected="form.stateCode"
              />
            </div>
            <b-form-group class="mt-3 ml-4 text-left" label>
              <b-form-radio-group
                v-model="selected"
                :options="options"
              ></b-form-radio-group>
            </b-form-group>
            <div class="col-10 mt-3" v-if="selected == 'V'">
              <div class="row">
                <div class="col-6">
                  <p class="m-0 p-0 pt-1 partner-reg">Business Category</p>
                  <w-drop-down
                    class="width-control-small"
                    :options="businessCategory"
                    @dropdownChange="getBusinessCategoryValue($event)"
                    :selected="form.categoryCode"
                  />
                </div>
                <div class="col-6">
                  <p class="m-0 p-0 pt-1 partner-reg">Business Sub-Category</p>
                  <w-drop-down
                    class="width-control-small"
                    :options="businessSubCategory"
                    :disabled="!form.categoryCode"
                    @dropdownChange="getBusinessSubCategoryValue($event)"
                    :selected="form.subCategoryCode"
                  />
                </div>
              </div>
            </div>
            <w-text-input
              class="text-left col-10 mt-4 ml-1"
              :labelName="$t('GST Identification no.')"
              @textInputChange="getGstNumber($event)"
              validation="required|regex_gst"
              :defaultValue="form.gstNumber"
              :maxCharacter="'50'"
            />
            <p
              class="mt-n2 ml-4 font-weight-bold text-danger lato-regular"
              v-if="gstDuplicate == true"
            >
              GST Number is already used
            </p>
            <div class="row ml-2">
              <w-datepicker
                class="text-left col-5 mt-4"
                :inputLabel="'GST registration date'"
                :inputPlaceholder="$t('select date')"
                :errorMessage="''"
                :dateRange="''"
                @inputChange="getGSTRegisterDate($event)"
                :v-validate="'required'"
                :gstDateValidator="3"
                :defaultValue="form.gstRegistrationDate"
              />
              <div class="text-left col-5 mt-4">
                <!-- <p class="p-0 m-0 pb-1 lato-regular field-headings">GST Effective From</p> -->
                <w-datepicker
                  class="text-left"
                  :inputLabel="'GST Effective From'"
                  :inputPlaceholder="$t('select date')"
                  :errorMessage="''"
                  :dateRange="''"
                  @inputChange="getGSTEffectiveFromDate($event)"
                  :v-validate="'required'"
                  :gstDateValidator="3"
                  :defaultValue="form.gstEffectiveFrom"
                />
                <!-- <date-picker
                v-model="selectedDateRange"
                range
                :lang="'en'"
                confirm
                @confirm="gstEffectiveDate($event,i)"
                :format="'D-MMM-YYYY'"
                :shortcuts="false"
                :not-after="disableDateAfter"
                :not-before="disableDateBefore"
                class="w-100"
                :disabled="!form.gstRegistrationDate"
              ></date-picker>-->
              </div>
            </div>
            <w-text-input
              class="text-left col-10 mt-4 ml-1"
              :labelName="$t('Threshold turnover limit')"
              @textInputChange="getTurnOver($event)"
              validation="required"
              :defaultValue="form.thresholdTurnoverLimit"
              :type="'number'"
              :maxCharacter="'8'"
            />
            <div class="col-10 mt-3 ml-1 mb-3">
              <p class="m-0 p-0 pt-1 partner-reg">Type of Dealers</p>
              <w-drop-down
                class="width-control-small"
                :options="gstDealersDropDown"
                @dropdownChange="getGstDealersType($event)"
                :selected="form.dealerTypeCode"
              />
            </div>
            <div>
              <FileUploader
                class="text-left ml-4"
                :id="'gstDocumentId'"
                :heading="'Attach Cancelled cheque or Relevant documents/proofs *'"
                @fileInputChange="getGSTAttachment($event)"
              />
              <div class="col-10 ml-4 mt-1 p-0 pt-1" v-if="form.gstDocumentId">
                <ul style="list-style-type: disc">
                  <li>
                    <a @click="showAttachFile(form.gstDocumentId)" href="#">{{
                      getFileName(form.gstDocumentId)
                    }}</a>
                  </li>
                </ul>
              </div>
            </div>
            <div
              class="mb-2"
              v-if="form.dealerTypeCode == 3 || form.dealerTypeCode == 4"
            >
              <div class="row ml-1">
                <div class="col-5 mt-3">
                  <p class="m-0 p-0 pt-1 partner-reg">Orgin Country</p>
                  <w-drop-down
                    class="width-control-small"
                    :options="countryDropDown"
                    @dropdownChange="getWorkRegisteredCountry($event)"
                    :selected="form.originCountryCode"
                  />
                </div>
                <div class="col-5 mt-3">
                  <p class="m-0 p-0 pt-1 partner-reg">Orgin State</p>
                  <w-drop-down
                    class="width-control-small"
                    :options="gstStateDropDown"
                    :disabled="!form.originCountryCode"
                    @dropdownChange="getWorkResgisteredGstState($event)"
                    :selected="form.originStateCode"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-5 mt-2">
                  <p class="m-0 p-0 pt-1 ml-1 pl-3 partner-reg">Work Country</p>
                  <p class="m-0 p-0 pl-3 ml-1 partner-reg-subText">India</p>
                </div>
                <div class="col-5 ml-2 mt-2">
                  <p class="m-0 p-0 pt-1 partner-reg">Work State</p>
                  <w-drop-down
                    class="width-control-small"
                    :options="gststatelist"
                    @dropdownChange="getGstWorkState($event)"
                    :selected="form.workStateCode"
                  />
                </div>
              </div>
              <w-text-input
                class="text-left col-10 mt-4 ml-1"
                :labelName="$t('Registration No.')"
                @textInputChange="getGstRegisterNumber($event)"
                validation="required"
                :defaultValue="form.registrationNumber"
                :maxCharacter="'15'"
              />
              <div class="row ml-2">
                <w-datepicker
                  class="text-left col-5 mt-4"
                  :inputLabel="'Registration Date'"
                  :inputPlaceholder="$t('select date')"
                  :errorMessage="''"
                  :dateRange="''"
                  @inputChange="getRegisterDate($event)"
                  :v-validate="'required'"
                  :gstDateValidator="3"
                  :defaultValue="form.registrationDate"
                />
                <div class="text-left col-5 mt-4 ml-1">
                  <!-- <p class="p-0 m-0 pb-1 lato-regular field-headings">GST Effective From to</p> -->
                  <w-datepicker
                    class="text-left"
                    :inputLabel="'GST Effective From'"
                    :inputPlaceholder="$t('select date')"
                    :errorMessage="''"
                    :dateRange="''"
                    @inputChange="getEffectiveTimeFrom($event)"
                    :v-validate="'required'"
                    :gstDateValidator="3"
                    :defaultValue="form.effectiveFrom"
                  />
                  <!-- <date-picker
                  v-model="validityTimePeriod"
                  range
                  :lang="'en'"
                  confirm
                  @confirm="gstEffectiveTimePeriod($event,i)"
                  :format="'D-MMM-YYYY'"
                  :shortcuts="false"
                  :not-after="gstDisableDateAfter"
                  :not-before="gstDisableDateBefore"
                  class="w-100"
                  :disabled="!form.registrationDate"
                ></date-picker>-->
                </div>
              </div>
            </div>
            <hr class="m-0 p-0 mr-3 ml-3" />
            <!-- <div>
            <b-button
              class="float-right mr-3 mt-2 mb-2 save-gst-button"
              @click="saveGstDetails(editModal)"
              :disabled="checkValidation()"
            >
              <span v-if="editModal">Update Gst Details</span>
              <span v-else>Save Gst Details</span>
            </b-button>
          </div>-->
          </div>
        </div>
      </b-modal>
      <w-modal
        :trigger="triggerModal"
        :text="lastResponse"
        :title="modalTitle"
        :centered="true"
        :dontCloseWhenClickedOutside="true"
        :dontCloseWhenEscapePressed="true"
        :dontShowCloseIcon="true"
        :modalbuttonStyle="true"
        :showAlert="alertModal"
        :showSuccess="successModal"
        @eventClose="closeTriggerdModal()"
      />
    </div>
  </div>
</template>
<script>
import axios from "axios";
import certificateModal from "../../widgets/PPQuicklinkCertificateModal";
import loadingSpinner from "../../widgets/LoadingSpinner";
import widgetModal from "../../widgets/newModalWidget";
import contactModal from "../../widgets/PPQuicklinkContactModal";
import taxcontactModel from "../../widgets/TaxContactModel.vue";
import financialModal from "../../widgets/PPQuicklinkFinanceModal";
import addressModal from "../../widgets/PPQuicklinkAddressModal";
import statutoryModal from "../../widgets/PPQuicklinkStatutoryModal";
import bankModal from "../../widgets/PPQuicklinkBankModal";
import confirmationModal from "../../widgets/confirmationModal";
import { PartnerService } from "../../services/partnerService";
import { OnBoardingServices } from "../../services/onBoardingService";
import { SummaryServices } from "../../services/summaryService";
import ButtonInputVue from "../../widgets/ButtonInput.vue";
import partnertable from "../../widgets/partner-table-collapsable";
import Modal from "../../widgets/newModalWidget";
import TextInput from "../../widgets/TextInput.vue";
import DropDown from "../../widgets/DropDown";
import Datepicker from "../../widgets/DatePicker";
import moment from "moment";
import DatePicker from "vue2-datepicker";
import multiSelect from "vue-multi-select";
import multiSelectVue from "../../widgets/multiSelect.vue";
import { VueperSlides, VueperSlide } from "vueperslides";
import partnerTable from "../../widgets/partner-table";
import DropDownBC from "../../widgets/DropDown";
import FileUploader from "../../widgets/FileUploader";
const OnBoardingService = new OnBoardingServices();
const partnerService = new PartnerService();
const summaryService = new SummaryServices();
export default {
  components: {
    "w-certificate": certificateModal,
    "w-loadingSpinner": loadingSpinner,
    "w-contact": contactModal,
    "w-taxContact": taxcontactModel,
    "w-address": addressModal,
    "w-statutory": statutoryModal,
    "w-finance": financialModal,
    "w-confirm": confirmationModal,
    "w-bank": bankModal,
    "w-button-input": ButtonInputVue,
    "w-collapse-table": partnertable,
    "w-drop-down": DropDown,
    "w-text-input": TextInput,
    "w-datepicker": Datepicker,
    "w-dropdown": DropDownBC,
    multiSelect,
    "w-multi-select-dropdown": multiSelectVue,
    DatePicker,
    "w-modal": Modal,
    "w-partner-table": partnerTable,
    widgetModal,
    VueperSlides,
    VueperSlide,
    confirmationModal,
    FileUploader,
  },
  props: ["quickLinkDetails", "currentCategoryCode", "primaryBusiness"],
  data() {
    return {
      statutoryDetails: {},
      statutoryQLDetails: [],
      approvedAddrList: [],
      qlAddrList: [],
      listOfPendingGST: [],
      listOfApprovedGST: [],
      selectedStatusFilter: "all",
      selectedStatusFilterCode: 0,
      activeFirstTab: true,
      techActiveFirstTab: 0,
      finActiveFirstTab: 0,
      showKycAcceptDiv: false,
      currentDate: new Date(),
      enableKycAcceptDiv: false,
      isChecked: false,
      kycAcceptedDate: null,
      techModTypes: [
        {
          text: "Business Categories",
        },
        {
          text: "Contact Details & Certificates",
        },
        {
          text: "Address Details",
        },
        {
          text: "Tax Contact Details",
        },
      ],
      interfinModTypes: [
        {
          text: "Bank details",
        },
        {
          text: "Statutory Details",
        },
      ],
      finModTypes: [
        {
          text: "GST Details",
        },
        {
          text: "Bank details",
        },
        {
          text: "Statutory Details",
        },
        {
          text: "Financial Performance",
        },
      ],
      modTypes: [
        {
          text: "Technical",
        },
        {
          text: "Financial",
        },
      ],
      modTypes: [
        {
          text: "Technical",
        },
        {
          text: "Financial",
        },
      ],
      activeStatusStyle: "",
      quickLinkDetails: [],
      quickLinkContactDetails: [],
      TaxContactDetails: [],
      quickLinkAnswerDetails: [],
      quickLinkFinanceDetails: [],
      quickLinkBankDetails: [],
      loading: false,
      lastResponse: "",
      triggerModal: false,
      triggerModalcert: false,
      questionList: [],
      editAnswers: [],
      editContact: [],
      editAddress: [],
      editStatutory: [],
      passStatutory: {},
      editFinance: [],
      editBank: [],
      questionCode: "",
      moduleCode: "",
      answerNumber: "",
      isEditClicked: false,
      isEditContactClicked: false,
      isEditTaxContactClicked: true,
      editTaxContact: [],
      isEditAddressClicked: false,
      isEditStatutoryClicked: false,
      isEditFinanceClicked: false,
      isEditBankClicked: false,
      triggerModalWidget: false,
      triggerContactModal: false,
      triggerAddressModal: false,
      triggerStatutoryModal: false,
      triggerFinanceModal: false,
      triggerBankModal: false,
      triggerConfirmModal: false,
      confirmDelete: false,
      modalTitle: "",
      alertModal: false,
      successModal: false,
      quickLinkDescription: "",
      companyCode: "",
      categoryCode: "",
      UnfilledFinancialYear: [],
      documentNumber: "",
      partnerInfo: { partnerId: "", userId: "", currentCompanyCode: "" },
      deleteContactData: null,
      deleteCertificateData: null,
      deleteFinanceData: null,
      deleteBankData: null,
      isSubmitDisable: true,
      approvedCount: 0,
      createdCount: 0,
      pendingCount: 0,
      sendbackCount: 0,
      rejectedCount: 0,
      gstapprovedCount: 0,
      gstcreatedCount: 0,
      gstpendingCount: 0,
      gstsendbackCount: 0,
      gstrejectedCount: 0,
      allCount: 0,
      isContact: true,
      isAnswer: true,
      isAddMoreDisabled: false,
      openTrackingModal: false,
      trackingDetails: [],
      roleName: [],

      gstDuplicate: false,
      selectedDateRange: [],
      dismissCountDown: 0,
      dismissSecs: 5,
      errorMessage: "",
      disableDateBefore: "",
      disableDateAfter: "",
      validityTimePeriod: [],
      gstDisableDateAfter: "",
      gstDisableDateBefore: "",
      openModal: false,
      modeOfGST: "",
      gststatelist: [],
      gstOrginstatelist: [],
      gstStateDropDown: [],
      triggerModal: false,
      lastResponse: "",
      alertModal: false,
      successModal: false,
      categoryCode: "",
      options: [
        { text: "Single Registration", value: "S" },
        { text: "Vertical Registration", value: "V" },
      ],
      selected: "",
      stateCode: "",
      enableSubmit: true,
      loading: false,
      openTrackingModal: false,
      trackingDetails: [],
      roleName: [],
      form: {
        slNo: null,
        categoryCode: null,
        subCategoryCode: null,
        companyCode: null,
        dealerTypeCode: null,
        stateCode: null,
        thresholdTurnoverLimit: null,
        gstEffectiveFrom: null,
        gstEffectiveUpto: null,
        gstNumber: null,
        gstRegistrationDate: null,
        originCountryCode: null,
        originStateCode: null,
        registrationDate: null,
        registrationNumber: null,
        registrationType: null,
        effectiveFrom: null,
        effectiveUpto: null,
        workCountryCode: 100,
        workStateCode: null,
        dontShowApprovedList: false,
        gstButtonEnable: false,
        gstDocumentId: "",
        siteUrl: "",
      },
      state: {
        disabledDates: {
          from: "",
          to: "",
        },
      },
      gstTableDataList: {
        fields: [
          {
            key: "typeOfRegistration",
            label: "Registration Type",
            thClass: "thClassLeft",
            tdClass: "text-left",
          },
          {
            key: "state",
            label: "State",
            thClass: "thClassLeft",
            tdClass: "text-left",
          },
          {
            key: "gstinNumber",
            label: "GST Number",
            thClass: "thClassLeft",
            tdClass: "text-left",
          },
          {
            key: "thresholdTurnoverLimit",
            label: "Threshold Limit",
            thClass: "thClassRight",
            tdClass: "text-right",
          },
          {
            key: "gstRegistrationDate",
            label: "Registration Date",
            thClass: "thClassCenter",
            tdClass: "text-center",
          },
          {
            key: "gstGstEffectiveDate",
            label: "GST Effective Period",
            thClass: "thClassCenter",
            tdClass: "text-center",
          },
          {
            key: "remarks",
            label: "Remarks",
            thClass: "thClassCenter",
            tdClass: "text-center",
          },
          {
            key: "dealerType",
            label: "Delear Type",
            thClass: "thClassLeft",
            tdClass: "text-left",
          },
          {
            key: "isValid",
            label: "Is Valid",
            thClass: "thClassLeft",
            tdClass: "text-left",
          },
          {
            key: "isActive",
            label: "Is Active",
            thClass: "thClassLeft",
            tdClass: "text-left",
          },
          {
            key: "toggle_icon",
            label: "",
            thClass: "table-action",
            tdClass: "text-center",
          },
        ],
        items: [],
      },
      gstPendingTableDataList: {
        fields: [
          {
            key: "typeOfRegistration",
            label: "Registration Type",
            thClass: "thClassLeft",
            tdClass: "text-left",
          },
          {
            key: "state",
            label: "State",
            thClass: "thClassLeft",
            tdClass: "text-left",
          },
          {
            key: "gstinNumber",
            label: "GST Number",
            thClass: "thClassLeft",
            tdClass: "text-left",
          },
          {
            key: "thresholdTurnoverLimit",
            label: "Threshold Limit",
            thClass: "thClassRight",
            tdClass: "text-right",
          },
          {
            key: "gstRegistrationDate",
            label: "Registration Date",
            thClass: "thClassCenter",
            tdClass: "text-center",
          },
          {
            key: "gstGstEffectiveDate",
            label: "GST Effective Period",
            thClass: "thClassCenter",
            tdClass: "text-center",
          },
          {
            key: "remarks",
            label: "Remarks",
            thClass: "thClassCenter",
            tdClass: "text-center",
          },
          {
            key: "dealerType",
            label: "Delear Type",
            thClass: "thClassLeft",
            tdClass: "text-left",
          },
          {
            key: "documentNo",
            label: "Document Ref.No",
            thClass: "thClassLeft",
            tdClass: "text-left",
          },
          {
            key: "toggle_icon",
            label: "",
            thClass: "table-action",
            tdClass: "text-left",
          },
        ],
        items: [],
      },
      editModal: false,
      approvedEditList: false,
      partnerDetailsFilterText: "",
      gstDealersDropDown: [],
      countryDropDown: [
        { value: null, text: "Select Country", disabled: true },
      ],
      businessCategory: [],
      businessSubCategory: [],
      partnerDetailInfo: "",
      isAadharApplicable: false,
      gstDocumentNumber: "",
      gstActionStatus: "",
      tempGstPendingDetails: [],
      partnerDetailInfo: "",
      companyCode: "",
      businessCategoryApprovedList: {
        fields: [
          {
            key: "partnerTypeABC",
            label: "Partner Type",
            thClass: "thClassLeft",
            tdClass: "text-left",
          },
          {
            key: "categoriesABC",
            label: "Categories",
            thClass: "thClassLeft",
            tdClass: "text-left",
          },
          {
            key: "subCategoriesABC",
            label: "Sub Categories",
            thClass: "thClassLeft",
            tdClass: "text-left",
          },
        ],
        items: [],
      },
      businessCategoryNotApprovedList: {
        fields: [
          {
            key: "documentNumberNABC",
            label: "Document Number",
            thClass: "thClassLeft",
            tdClass: "text-left",
          },
          {
            key: "partnerTypeNABC",
            label: "Partner Type",
            thClass: "thClassLeft",
            tdClass: "text-left",
          },
          {
            key: "categoriesNABC",
            label: "Categories",
            thClass: "thClassLeft",
            tdClass: "text-left",
          },
          {
            key: "subCategoriesNABC",
            label: "Sub Categories",
            thClass: "thClassLeft",
            tdClass: "text-left",
          },
          {
            key: "actionNABC",
            label: "Action",
            thClass: "thClassLeft",
            tdClass: "text-left",
          },
        ],
        items: [],
      },
      tempNotApprovedList: {
        fields: [
          {
            key: "documentNumberNABC",
            label: "Document Number",
            thClass: "thClassLeft",
            tdClass: "text-left",
          },
          {
            key: "partnerTypeNABC",
            label: "Partner Type",
            thClass: "thClassLeft",
            tdClass: "text-left",
          },
          {
            key: "categoriesNABC",
            label: "Categories",
            thClass: "thClassLeft",
            tdClass: "text-left",
          },
          {
            key: "subCategoriesNABC",
            label: "Sub Categories",
            thClass: "thClassLeft",
            tdClass: "text-left",
          },
          {
            key: "actionNABC",
            label: "Action",
            thClass: "thClassLeft",
            tdClass: "text-left",
          },
        ],
        items: [],
      },
      businessCategoryFilterText: "",
      openModal: false,
      editModal: false,
      enableSubmit: true,
      wantToSubmit: true,
      partnerList: [{ text: "Select One", value: null, disabled: true }],
      selectedPartnerType: "",
      selectedCategories: [],
      selectedSubCategories: [],
      position: "bottom",
      optionsCategory: {
        multi: true,
        groups: false,
        labelList: "elements",
        groupName: "title",
        cssSelected: (option) =>
          option.selected ? { "background-color": "#ffffff" } : "",
      },
      optionsSubCategory: {
        multi: true,
        groups: false,
        labelList: "elements",
        groupName: "title",
        cssSelected: (option) =>
          option.selected ? { "background-color": "#ffffff" } : "",
      },
      partnerCategory: [],
      partnerSubCategory: [],
      btnLabelPartnerCategory: (values) =>
        `Selected Categories (${values.length})`,
      btnLabelPartnerSubCategory: (values) =>
        `Selected Sub-Categories (${values.length})`,
      bccreatedCount: 0,
      bcpendingCount: 0,
      bcrejcetedCount: 0,
      triggerModalWidgetBC: false,
      lastResponseBC: "",
      modalTitle: "Partner Portal",
      alertModal: false,
      successModal: false,
      triggerConfirmModalBC: false,
      lastResponseConfirmBC: "",
      tempBCDetails: [],
      tempDocumentNumber: null,
      submitForApproval: false,
      tempListCats: [],
      tempListSubCats: [],
      increaseHeight: false,
    };
  },
  created() {
    this.getPartnerInfo();
    this.getPartnerInfoForCategories();
    this.getPartnerApprovedBusinessCategory();
    this.getPartnerNotApprovedBusinessCategory();
    this.getpartnerDetails();
    this.projectStatusDetails();
    console.log(this.quickLinkDetails);
    this.quickLinkContactDetails = this.quickLinkDetails.contacts;
    for (let j = 0; j < this.quickLinkDetails.answer.length; j++) {
      this.quickLinkAnswerDetails = this.quickLinkDetails.answer[j].answerList;
    }
    this.quickLinkFinanceDetails = this.quickLinkDetails.financeDetails;
    this.quickLinkBankDetails = this.quickLinkDetails.bankDetails;
  },
  // beforemounted() {
  //   this.quickLinkContactDetails = this.quickLinkDetails.contacts;
  //   for (let j = 0; j < this.quickLinkDetails.answer.length; j++) {
  //     this.quickLinkAnswerDetails = this.quickLinkDetails.answer[j].answerList;
  //   }
  //   this.quickLinkFinanceDetails = this.quickLinkDetails.financeDetails;
  //   this.quickLinkBankDetails = this.quickLinkDetails.bankDetails;
  //   alert("Called in Mounted");
  // },
  // beforeupdated() {
  //   this.approvedCount = 0;
  //   this.createdCount = 0;
  //   this.pendingCount = 0;
  //   this.sendbackCount = 0;
  //   this.rejectedCount = 0;
  //   this.allCount = 0;
  //   this.projectStatusDetails();
  //   //alert("In Updated");
  // },
  methods: {
    deleteAddrDetail(addr) {
      if (
        window.confirm(
          "Do you really want to delete this address. Click OK to confirm?"
        )
      ) {
        var data = {
          addressTypeCode: addr.addressTypeCode,
          categoryCode: this.currentCategoryCode,
          companyCode: this.companyCode,
          partnerId: this.partnerInfo.partnerId,
          slno: addr.slno,
        };
        partnerService
          .deleteAddressQL(data)
          .then((res) => {
            if (res.response) {
              this.loading = false;
              window.alert(res.response);
            }
            if (res.failureMessage) {
              window.alert(res.failureMessage);
              this.loading = false;
            }

            this.getAddressTabData();
          })
          .catch((e) => {
            window.alert("Something went wrong! try again later");
            this.loading = false;
          });
      }
    },
    checkKYCAcceptedDate() {
      var data = {
        partnerId: this.partnerInfo.partnerId,
      };
      partnerService
        .getKYCAcceptedDate(data)
        .then((resp) => {
          if (resp.status == "SUCCESS") {
            var rekycApplicabilityDate = new Date(resp.response.rekycApplicabilityDate);
            // console.log(rekycApplicabilityDate);
            // console.log(this.currentDate);
            if(rekycApplicabilityDate <= this.currentDate){
              this.enableKycAcceptDiv = true;
              console.log(resp.response.rekycApplicabilityDate);

            }else{
              this.enableKycAcceptDiv = false;
            }
            if (resp.response.kycAcceptedDate == null) {              
              this.showKycAcceptDiv = true;
            } 
            else {            
              this.kycAcceptedDate = new Date(resp.response.kycAcceptedDate).toISOString().split('T')[0];  
              this.showKycAcceptDiv = false;
            }
            return;
          } else {
            window.alert(resp.failureMessage);
            location.reload();
          }
        })
        .catch((error) => {
          if (error.failureMessage != "") {
            window.alert(error.failureMessage);
            this.loading = false;
            location.reload();
          } else {
            window.alert("Something went wrong!");
            location.reload();
          }
        });
    },
    handleButtonClick() {
      var data = {
        partnerId: this.partnerInfo.partnerId,
      };
      partnerService
        .submitKYCAcceptedDate(data)
        .then((resp) => {
          if (resp.status == "SUCCESS") {
            window.alert(resp.response);
            this.checkKYCAcceptedDate();
            this.showKycAcceptDiv = false;
            return;
          } else {
            window.alert(resp.failureMessage);
            location.reload();
          }
        })
        .catch((error) => {
          if (error.failureMessage != "") {
            window.alert(error.failureMessage);
            this.loading = false;
            location.reload();
          } else {
            window.alert("Something went wrong!");
            location.reload();
          }
        });
    },
    getStatus(c, uBy) {
      if (c == 1) {
        return "Approved";
      }
      if (c == 2) {
        return "Sentback";
      }
      if (c == 3) {
        return "Rejected";
      }
      if (c == 4) {
        return "Pending";
      }
      if (c == 7) {
        return "Draft";
      }
      return "";
    },
    showGSTs() {
      partnerService
        .getAllGsts(this.companyCode)
        .then((res) => {
          if (res) {
            this.loading = false;
            this.openModal = false;
            this.editModal = false;
            var gsts = res.response.gstInList;
            if (gsts && gsts.length > 0) {
              this.triggerModalWidgetBC = true;
              var content = "";
              gsts.forEach((x) => {
                content =
                  content +
                  '<div style="text-align:left;font-weight:normal;font-size:12px;">' +
                  x.gstinNumber +
                  " | " +
                  (x.isActive == "N" ? "Inactive" : "Active") +
                  " | " +
                  (x.isValid == "N" ? "Invalid" : "Valid") +
                  " | " +
                  x.typeOfRegistration.replace("Registration", "") +
                  " | " +
                  this.getStatus(x.statusCode) +
                  "</div>";
              });
              this.lastResponseBC = content;
              this.successModal = true;
            } else {
              window.alert("No GST to list.");
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    generateNoRecordFoundMessage(obj) {
      var self = this;
      if (self.selectedStatusFilter != "all") {
        var res1 = obj.filter(
          (x) => x.status == self.selectedStatusFilter
        ).length;
        if (res1 == 0) {
          if (self.selectedStatusFilter == "A")
            return "No records in Approved status. Try different status filter!";
          if (self.selectedStatusFilter == "S")
            return "No records in Sendback status. Try different status filter!";
          if (self.selectedStatusFilter == "R")
            return "No records in Rejected status. Try different status filter!";
          if (self.selectedStatusFilter == "C")
            return "No records in Pending status. Try different status filter!";
          if (self.selectedStatusFilter == "N")
            return "No records in Created status. Try different status filter!";
        }
      } else {
        var res2 = this.allCount;
        if (res2 == 0) {
          return "No records found!";
        }
      }
    },
    generateNoRecordFoundMessageContact(obj) {
      var self = this;
      if (self.selectedStatusFilter != "all") {
        var res1 = obj.filter(
          (x) => x.status == self.selectedStatusFilterCode
        ).length;
        if (res1 == 0) {
          if (self.selectedStatusFilterCode == 1)
            return "No records in Approved status. Try different status filter!";
          if (self.selectedStatusFilterCode == 2)
            return "No records in Sendback status. Try different status filter!";
          if (self.selectedStatusFilterCode == 3)
            return "No records in Rejected status. Try different status filter!";
          if (self.selectedStatusFilterCode == 4)
            return "No records in Pending status. Try different status filter!";
          if (self.selectedStatusFilterCode == 7)
            return "No records in Created status. Try different status filter!";
        }
      } else {
        var res2 = this.allCount;
        if (res2 == 0) {
          return "No records found!";
        }
      }
    },
    getStatusv(e, uBy, cc) {
      var status = "";
      if (e == 1 && uBy != 1) status = "Approved";
      if (e == 1 && uBy == 1) status = "Not-Certified";
      if (e == 2) status = "SendBack";
      if (e == 3) status = "Rejected";
      if (e == 4) status = "Pending";
      if (e == 7) status = "Draft";

      if (cc == 2 && e == 1) {
        status = "Not-Certified";
      }

      return status;
    },
    getPartnerInfoForCategories() {
      this.loading = true;
      partnerService
        .getPartnerInfo()
        .then((res) => {
          if (res) {
            this.partnerDetailInfo = res.response;
            var idvalue = this.partnerDetailInfo.idCardValue;
            if (
              idvalue.toUpperCase().charAt(3) == "P" ||
              idvalue.toUpperCase().charAt(3) == "H"
            ) {
              this.isAadharApplicable = true;
            }
            this.companyCode = res.response.currentCompanyCode;
            this.$root.isInternational =
              res.response.countryDetail.countryCode == 100 ? false : true;
            if (this.$root.isInternational) {
              this.finActiveFirstTab = 0;
            }
            partnerService
              .getPartnertype(this.companyCode)
              .then((resp) => {
                if (resp.response) {
                  resp.response.forEach((item, index) => {
                    if (item.status == "A") {
                      this.partnerList.push({
                        text: item.description,
                        value: item.partnerTypeCode,
                      });
                    }
                  });
                }
              })
              .catch((err) => {
                console.log(err);
              });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getPartnerApprovedBusinessCategory() {
      this.businessCategoryApprovedList.items = [];
      partnerService
        .getPartnerApprovedBusinessCategories()
        .then((res) => {
          if (res) {
            // this.businessCategoryApprovedList.items.push(
            //   res.response.primaryBusiness
            // );
            // for (let i = 0; i < res.response.secondaryBusiness.length; i++) {
            //   this.businessCategoryApprovedList.items.push(
            //     res.response.secondaryBusiness[i]
            //   );
            // }
            for (let i = 0; i < res.response.length; i++) {
              this.businessCategoryApprovedList.items.push(
                res.response[i].businessDetails
              );
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getPartnerNotApprovedBusinessCategory() {
      this.businessCategoryNotApprovedList.items = [];
      partnerService
        .getPartnerNotApprovedBusinessCategories()
        .then((res) => {
          if (res) {
            this.bccreatedCount = 0;
            this.bcpendingCount = 0;
            this.bcrejcetedCount = 0;
            this.tempNotApprovedList.items = [];
            for (let i = 0; i < res.response.length; i++) {
              this.businessCategoryNotApprovedList.items.push(res.response[i]);
              this.tempNotApprovedList.items.push(res.response[i]);
              if (res.response[i].statusCode == 7) {
                this.bccreatedCount += 1;
              }
              if (res.response[i].statusCode == 4) {
                this.bcpendingCount += 1;
              }
              if (res.response[i].statusCode == 3) {
                this.bcrejcetedCount += 1;
              }
            }
            this.loading = false;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    emptyAllFileds() {
      this.selectedPartnerType = "";
      this.selectedCategories = [];
      this.partnerCategory = [];
      this.selectedSubCategories = [];
      this.partnerSubCategory = [];
    },
    addNewBC() {
      this.openModal = true;
      this.editModal = false;
      this.emptyAllFileds();
    },
    getSelectedPartnerType(event) {
      this.selectedPartnerType = event;
      partnerService.getPartnerCategoriesWhichCanAddMore(event).then((resp) => {
        if (resp) {
          let res = resp.response;
          this.partnerCategory = [];
          this.primarySubCategory = [];
          for (let i = 0; i < res.length; i++) {
            let data = {};
            data.name = res[i].longDesc;
            data.value = res[i].categoryCode;
            this.partnerCategory.push(data);
          }
        }
      });
    },
    getPartnerCategory(event) {
      this.selectedSubCategories = [];
      this.partnerSubCategory = [];
      if (this.subCatSelectOpened != true) {
        this.increaseHeight = false;
      }
      this.catSelectOpened = false;
      if (event) {
        this.selectedCategories = event;
      }
      if (this.selectedCategories.length > 0) {
        var categoryData = [];
        this.selectedCategories.forEach((category) => {
          categoryData.push(category.value);
        });
        var subCategoryData = [];
        this.selectedSubCategories.forEach((category) => {
          subCategoryData.push(category.value);
        });
        partnerService
          .getPartnerSubCategoriesWhichCanAddMore(
            this.selectedPartnerType,
            categoryData,
            subCategoryData
          )
          .then((resp) => {
            let res = resp.response;
            this.partnerSubCategory = [];
            for (let i = 0; i < res.length; i++) {
              let data = {};
              data.name = res[i].longDesc;
              data.value = res[i].categoryCode;
              this.partnerSubCategory.push(data);
            }
            this.loading = false;
          });
      } else {
        this.partnerSubCategory = [];
      }
    },
    getPartnerSubCategory(event) {
      if (this.catSelectOpened != true) {
        this.increaseHeight = false;
      }
      this.subCatSelectOpened = false;
      if (event) {
        this.selectedSubCategories = [];
        event.forEach((subCat) => {
          this.selectedSubCategories.push(subCat);
        });
      }
    },
    checkValidationBC() {
      if (
        this.selectedPartnerType &&
        this.selectedCategories.length > 0 &&
        this.selectedSubCategories.length > 0
      ) {
        return false;
      } else {
        return true;
      }
    },
    saveSubmitBCDetails(event1, event2) {
      console.log("saveSubmitBCDetails");
      this.loading = true;
      var request = {
        partnerTypeCode: this.selectedPartnerType,
        documentNumber: null,
        statusCode: "",
        categories: "",
        subCategories: "",
      };
      if (event1 == true) {
        request.documentNumber = this.tempDocumentNumber;
      }
      var listCategories = [];
      this.selectedCategories.forEach((category) => {
        listCategories.push(category.value);
      });
      request.categories = listCategories;
      var listSubCategories = [];
      this.selectedSubCategories.forEach((category) => {
        listSubCategories.push(category.value);
      });
      request.subCategories = listSubCategories;

      if (event2 == true) {
        this.loading = false;
        request.statusCode = "C";
        console.log("r ", request);
        this.tempBCDetails = request;
        console.log("temp ", this.tempBCDetails);
        this.triggerConfirmModalBC = true;
        this.lastResponseConfirmBC = "Are you sure want to submit?";
      } else {
        request.statusCode = "N";
        partnerService
          .savePartnerAdditionalCategories(request)
          .then((res) => {
            if (res) {
              this.emptyAllFileds();
              this.loading = false;
              this.openModal = false;
              this.editModal = false;
              this.triggerModalWidgetBC = true;
              if (res.status == "SUCCESS") {
                if (event2 == true) {
                  this.lastResponseBC =
                    "Business Category Details Submitted successfully";
                } else if (event1 == true) {
                  this.lastResponseBC =
                    "Business Category Details Updated successfully";
                } else {
                  this.lastResponseBC =
                    "Business Category Details Saved successfully";
                }
                this.successModal = true;
              }
              if (res.status == "FAILURE") {
                if (event2 == true) {
                  this.lastResponseBC = res.failureMessage;
                } else if (event1 == true) {
                  this.lastResponseBC = res.failureMessage;
                } else {
                  this.lastResponseBC = res.failureMessage;
                }
                this.alertModal = true;
              }
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    clearBCDetails() {
      this.selectedPartnerType = "";
      this.selectedCategories = [];
      this.partnerCategory = [];
      this.selectedSubCategories = [];
      this.selectedSubCategories = [];
    },
    submitSavedBCDetails(event) {
      this.tempBCDetails = event;
      this.triggerConfirmModalBC = true;
      this.lastResponseConfirmBC = "Are you sure want to submit?";
    },
    submitCategoryDetails(event) {
      this.loading = true;
      var request = {
        partnerTypeCode: event.partnerTypeCode,
        documentNumber: event.documentNumber,
        statusCode: "C",
        categories: "",
        subCategories: "",
      };

      this.tempListCats = [];
      this.tempListSubCats = [];

      for (let i = 0; i < event.categories.length; i++) {
        if (event.categories[i].categoryCode == null) {
          this.tempListCats.push(event.categories[i]);
        } else {
          this.tempListCats.push(event.categories[i].categoryCode);
        }
      }
      request.categories = this.tempListCats;

      for (let i = 0; i < event.subCategories.length; i++) {
        if (event.subCategories[i].categoryCode == null) {
          this.tempListSubCats.push(event.subCategories[i]);
        } else {
          this.tempListSubCats.push(event.subCategories[i].categoryCode);
        }
      }
      request.subCategories = this.tempListSubCats;

      console.log("request ", request);
      partnerService
        .savePartnerAdditionalCategories(request)
        .then((res) => {
          if (res) {
            if (res.status == "SUCCESS") {
              this.loading = false;
              this.openModal = false;
              this.triggerModalWidgetBC = true;
              this.lastResponseBC =
                "Business Category Details Submitted Successfully";
              this.successModal = true;
            }
            if (res.status == "FAILURE") {
              this.loading = false;
              this.openModal = false;
              this.triggerModalWidgetBC = true;
              this.lastResponseBC = res.failureMessage;
              this.alertModal = true;
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    editCategoryDetails(event) {
      this.loading = true;
      this.openModal = true;
      this.editModal = true;
      this.selectedPartnerType = event.partnerTypeCode;
      this.tempDocumentNumber = event.documentNumber;

      this.getSelectedPartnerType(this.selectedPartnerType);
      this.selectedCategories = [];
      for (let i = 0; i < event.categories.length; i++) {
        let data = {};
        data.name = event.categories[i].categoryName;
        data.value = event.categories[i].categoryCode;
        this.selectedCategories.push(data);
      }

      this.selectedSubCategories = [];
      for (let i = 0; i < event.subCategories.length; i++) {
        let data = {};
        data.name = event.subCategories[i].categoryName;
        data.value = event.subCategories[i].categoryCode;
        this.selectedSubCategories.push(data);
      }
      this.getPartnerCategory(this.selectedCategories);
    },
    PBCByStatusCodes(statusCode, statusType) {
      var temp = [];
      this.tempNotApprovedList.items = [];
      for (
        let i = 0;
        i < this.businessCategoryNotApprovedList.items.length;
        i++
      ) {
        if (
          this.businessCategoryNotApprovedList.items[i].statusCode == statusCode
        ) {
          this.tempNotApprovedList.items.push(
            this.businessCategoryNotApprovedList.items[i]
          );
        }
      }
    },
    bindCategoryValue(category) {
      var selectedBussiness = [];
      if (this.partnerCategory) {
        this.partnerCategory.forEach((element) => {
          category.forEach((data) => {
            if (element.value == data.value) {
              selectedBussiness.push({
                name: element.name,
                value: element.value,
              });
            }
          });
        });
      }
      return selectedBussiness;
    },
    bindSubCategoryValue(subCategory) {
      var selectedBussiness = [];
      if (this.partnerSubCategory) {
        this.partnerSubCategory.forEach((element) => {
          subCategory.forEach((data) => {
            if (element.value == data.value) {
              selectedBussiness.push({
                name: element.name,
                value: element.value,
              });
            }
          });
        });
      }
      return selectedBussiness;
    },
    closeAddBCModal(event) {
      this.openModal = false;
      this.editModal = false;
    },
    changeModalSuccessBC() {
      this.triggerModalWidgetBC = false;
      this.lastResponseBC = "";
      this.successModal = false;
      this.loading = true;
      this.getPartnerApprovedBusinessCategory();
      this.getPartnerNotApprovedBusinessCategory();
    },
    callAfterConfirmModalBC() {
      this.triggerConfirmModalBC = false;
      console.log("temp ", this.tempBCDetails);
      this.submitCategoryDetails(this.tempBCDetails, "submit-bc-details");
    },
    closeConfirmModal() {
      this.triggerConfirmModal = false;
    },
    submitAllForApproval() {
      this.loading = true;
      var request = [];
      for (
        let i = 0;
        i < this.businessCategoryNotApprovedList.items.length;
        i++
      ) {
        if (this.businessCategoryNotApprovedList.items[i].statusCode == 7) {
          request.push(this.businessCategoryNotApprovedList.items[i]);
        }
      }
      console.log(request);
      this.loading = false;
    },
    increaseModalHeight(event) {
      console.log("cats ", this.selectedCategories);
      console.log("sub-cats ", this.selectedSubCategories);
      if (event == "Cat") {
        this.catSelectOpened = true;
        this.subCatSelectOpened = false;
      } else {
        this.catSelectOpened = false;
        this.subCatSelectOpened = true;
      }
      this.increaseHeight = true;
    },
    getTabData(event) {
      console.log(event);

      if (event == 0 && this.activeFirstTab == false) {
        this.activeFirstTab = true;
        // this.getJobWiseDropDown();
      } else if (event == 1 && this.activeFirstTab == true) {
        this.activeFirstTab = false;
      }
    },
    getTechTabData(event) {
      console.log(event);
      this.techActiveFirstTab = event;
      if (event == 2) {
        this.getAddressTabData();
      }
      if (event == 3) {
        this.changeSuccess();
      }
    },
    editStatutoryDetails() {},
    getStatutoryTabData() {
      var self = this;
      var data = {
        categoryCode: self.currentCategoryCode,
        companyCode: self.companyCode,
        partnerId: this.partnerInfo.partnerId,
        userId: this.partnerInfo.userId,
      };

      this.statutoryDetails = {};
      partnerService
        .getApprovedStatutoryDetails(data)
        .then((res) => {
          if (res.status == "SUCCESS") {
            this.statutoryDetails = res.response;
          } else {
            console.log(res.failureMessage);
          }
        })
        .catch((err) => {
          console.log(err);
        });

      this.statutoryQLDetails = [];
      partnerService
        .getQLStatutoryDetails(data)
        .then((res) => {
          if (res.status == "SUCCESS") {
            this.statutoryQLDetails = res.response;
          } else {
            console.log(res.failureMessage);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getAddressTabData() {
      var self = this;
      var data = {
        categoryCode: self.currentCategoryCode,
        companyCode: self.companyCode,
        partnerId: this.partnerInfo.partnerId,
        userId: this.partnerInfo.userId,
      };

      this.qlAddrList = [];
      this.approvedAddrList = [];
      partnerService
        .getApprovedAddrDetails(data)
        .then((res) => {
          if (res.status == "SUCCESS") {
            this.approvedAddrList = res.response;
          } else {
            window.alert(res.failureMessage);
          }
        })
        .catch((err) => {
          console.log(err);
        });
      partnerService
        .getQLAddrDetails(data)
        .then((res) => {
          if (res.status == "SUCCESS") {
            this.qlAddrList = res.response;
          } else {
            //window.alert(res.failureMessage)
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getFinTabData(event) {
      console.log(event);
      this.finActiveFirstTab = event;
      if (
        (!this.$root.isInternational && event == 2) ||
        (this.$root.isInternational && event == 1)
      ) {
        this.getStatutoryTabData();
      }
    },
    tabselectionstyle(event) {
      if (
        (0 === event && this.activeFirstTab == true) ||
        (1 === event && this.activeFirstTab == false)
      ) {
        return "requestListTabSelectionPartner";
      } else {
        return "defaulfRequestListTabSelectionPartner";
      }
    },
    techtabselectionstyle(event) {
      if (this.techActiveFirstTab == event) {
        return "requestListTabSelectionPartner";
      } else {
        return "defaulfRequestListTabSelectionPartner";
      }
    },
    fintabselectionstyle(event) {
      if (this.finActiveFirstTab == event) {
        return "requestListTabSelectionPartner";
      } else {
        return "defaulfRequestListTabSelectionPartner";
      }
    },
    projectStatusDetails() {
      var self = this;
      this.quickLinkDetails.answer.forEach((x, i) =>
        x.answerList.forEach(function (y) {
          if (y.status == "A") self.approvedCount = self.approvedCount + 1;
          if (y.status == "S") self.sendbackCount = self.sendbackCount + 1;
          if (y.status == "R") self.rejectedCount = self.rejectedCount + 1;
          if (y.status == "C") self.pendingCount = self.pendingCount + 1;
          if (y.status == "N") self.createdCount = self.createdCount + 1;
        })
      );
      this.quickLinkDetails.contacts.forEach(function (y) {
        if (y.status == 1) self.approvedCount = self.approvedCount + 1;
        if (y.status == 2) self.sendbackCount = self.sendbackCount + 1;
        if (y.status == 3) self.rejectedCount = self.rejectedCount + 1;
        if (y.status == 4) self.pendingCount = self.pendingCount + 1;
        if (y.status == 7) self.createdCount = self.createdCount + 1;
      });
      /*  for (let i = 0; i < this.quickLinkDetails.financeDetails.length; i++) {
        if (this.quickLinkDetails.financeDetails[i].statusCode == 1) {
          this.approvedCount = this.approvedCount + 1;
        } else if (this.quickLinkDetails.financeDetails[i].statusCode == 2) {
          this.sendbackCount = this.sendbackCount + 1;
        } else if (this.quickLinkDetails.financeDetails[i].statusCode == 3) {
          this.rejectedCount = this.rejectedCount + 1;
        } else if (this.quickLinkDetails.financeDetails[i].statusCode == 4) {
          this.pendingCount = this.pendingCount + 1;
        } else if (this.quickLinkDetails.financeDetails[i].statusCode == 7) {
          this.createdCount = this.createdCount + 1;
        }
      }
      for (let i = 0; i < this.quickLinkDetails.bankDetails.length; i++) {
        if (this.quickLinkDetails.bankDetails[i].statusCode == 1) {
          this.approvedCount = this.approvedCount + 1;
        } else if (this.quickLinkDetails.bankDetails[i].statusCode == 2) {
          this.sendbackCount = this.sendbackCount + 1;
        } else if (this.quickLinkDetails.bankDetails[i].statusCode == 3) {
          this.rejectedCount = this.rejectedCount + 1;
        } else if (this.quickLinkDetails.bankDetails[i].statusCode == 4) {
          this.pendingCount = this.pendingCount + 1;
        } else if (this.quickLinkDetails.bankDetails[i].statusCode == 7) {
          this.createdCount = this.createdCount + 1;
        }
      } */
      this.allCount =
        this.approvedCount +
        this.sendbackCount +
        this.rejectedCount +
        this.pendingCount +
        this.createdCount;
    },
    checkDeleteStatus(status) {
      if (status == "N" || status == 7) {
        return false;
      }
      return true;
    },
    checkEditStatus(status) {
      if (status == "N" || status == "A" || status == 1 || status == 7) {
        return false;
      }
      return true;
    },
    getUnfilledFinancialYear() {
      partnerService
        .getFinancialYearDropdown(this.currentCategoryCode, this.companyCode)
        .then((res) => {
          if (res.response) {
            this.UnfilledFinancialYear = res.response;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getFileName(fileName) {
      if (fileName == null) return "--";
      var fileNameFinal = "";
      fileNameFinal = fileName.split(/_(.+)/)[1];
      return fileNameFinal;
    },
    dateFormat(date) {
      return moment(date).format("Do MMM YYYY");
    },
    getPartnerInfo() {
      partnerService.getPartnerInfo().then((resp) => {
        this.partnerInfo = resp.response;
        this.$root.isInternational =
          resp.response.countryDetail.countryCode == 100 ? false : true;
        this.companyCode = resp.response.currentCompanyCode;
        this.getDocumentNumber();
        this.checkKYCAcceptedDate();
        // this.checkSubmit();
      });
    },
    callWidget(e) {
      console.log("calling widget");

      this.isEditStatutoryClicked = false;
      this.editStatutory = [];
      this.triggerStatutoryModal = false;
      this.isEditAddressClicked = false;
      this.editAddress = [];
      this.triggerAddressModal = false;
      this.triggerModal = false;
      this.triggerContactModal = false;
      this.isEditContactClicked = false;
      this.editContact = [];
      this.triggerFinanceModal = false;
      this.isEditFinanceClicked = false;
      this.editFinance = [];
      this.triggerBankModal = false;
      this.isEditBankClicked = false;
      this.editBank = [];
      this.triggerTaxContactModal = false;
      this.isEditTaxContactClicked = false;
      this.editTaxContact = [];
      this.triggerModalWidget = true;
      this.successModal = true;
      this.lastResponse = "Saved Successfully";
      this.getGstDocumentDetails();
      this.getDocumentNumber();
      this.getAddressTabData();
      this.getStatutoryTabData();
      this.changeSuccess();
      this.changeModalSuccess();
      // this.getUnfilledFinancialYear();
    },
    callAlertModal(e) {
      this.triggerContactModal = false;
      this.isEditContactClicked = false;
      this.editContact = [];
      this.triggerTaxContactModal = true;
      this.triggerModalWidget = true;
      this.alertModal = true;
      this.lastResponse = e;
      this.lastResponse =
        "Something went wrong while saving contact. Plz contact support";
    },
    callAddrAlertModal(e) {
      this.triggerAddressModal = false;
      this.isEditAddressClicked = false;
      this.editAddress = [];
      this.triggerModalWidget = true;
      this.alertModal = true;
      this.lastResponse = e;
      this.lastResponse =
        "Something went wrong while saving address. Plz contact support";
      this.getAddressTabData();
    },

    callStatutoryAlertModal(e) {
      this.triggerStatutoryModal = false;
      this.isEditStatutoryClicked = false;
      this.editStatutory = [];
      this.triggerModalWidget = true;
      this.alertModal = true;
      this.lastResponse = e;
      this.lastResponse =
        "Something went wrong while saving address. Plz contact support";
      this.getStatutoryTabData();
    },
    refreshPQL() {
      this.loading = true;
      partnerService
        .quickLinkPage(this.currentCategoryCode, this.companyCode)
        .then((res) => {
          this.quickLinkDetails = res.response;
          this.approvedCount = 0;
          this.createdCount = 0;
          this.pendingCount = 0;
          this.sendbackCount = 0;
          this.rejectedCount = 0;
          this.allCount = 0;
          this.projectStatusDetails();
          this.quickLinkContactDetails = this.quickLinkDetails.contacts;
          for (let j = 0; j < this.quickLinkDetails.answer.length; j++) {
            this.quickLinkAnswerDetails =
              this.quickLinkDetails.answer[j].answerList;
          }
          this.quickLinkFinanceDetails = this.quickLinkDetails.financeDetails;
          this.quickLinkBankDetails = this.quickLinkDetails.bankDetails;
          this.getDocumentNumber();
          this.loading = false;
          this.successModal = false;
        })
        .catch((e) => {
          this.getDocumentNumber();
          this.loading = false;
        });
    },
    changeModalSuccess() {
      if (this.successModal == true) {
        this.loading = true;
        partnerService
          .quickLinkPage(this.currentCategoryCode, this.companyCode)
          .then((res) => {
            this.quickLinkDetails = res.response;
            this.approvedCount = 0;
            this.createdCount = 0;
            this.pendingCount = 0;
            this.sendbackCount = 0;
            this.rejectedCount = 0;
            this.allCount = 0;
            this.projectStatusDetails();
            this.quickLinkContactDetails = this.quickLinkDetails.contacts;
            for (let j = 0; j < this.quickLinkDetails.answer.length; j++) {
              this.quickLinkAnswerDetails =
                this.quickLinkDetails.answer[j].answerList;
            }
            this.quickLinkFinanceDetails = this.quickLinkDetails.financeDetails;
            this.quickLinkBankDetails = this.quickLinkDetails.bankDetails;
            this.getDocumentNumber();
            this.loading = false;
            this.successModal = false;
          })
          .catch((e) => {
            this.getDocumentNumber();
            this.loading = false;
          });
      } else {
        this.alertModal = false;
      }
      this.triggerModalWidget = false;
    },
    closeContactModal() {
      this.isEditContactClicked = false;
      this.editContact = [];
      this.triggerContactModal = false;
      // location.reload();
    },
    closeTaxContactModal() {
      this.triggerTaxContactModal = false;
      this.isEditTaxContactClicked = false;
      this.editTaxContact = [];
    },
    closeAddressModal() {
      this.isEditAddressClicked = false;
      this.editAddress = [];
      this.triggerAddressModal = false;
      // location.reload();
    },
    closeStatutoryModal() {
      this.isEditStatutoryClicked = false;
      this.editStatutory = [];
      this.triggerStatutoryModal = false;
      // location.reload();
    },
    closeFinanceModal() {
      this.triggerFinanceModal = false;
      this.isEditFinanceClicked = false;
      this.editFinance = [];
    },
    closeBankModal() {
      this.triggerBankModal = false;
      this.isEditBankClicked = false;
      this.editBank = [];
    },
    callAfterConfirmModal() {
      this.confirmDelete = true;
      this.deleteContactCard(this.deleteContactData, "confirmDelete");
      this.deleteCertificateCard(this.deleteCertificateData, "confirmDelete");
      this.deleteFinanceDetail(this.deleteFinanceData, "confirmDelete");
      this.deleteBankDetail(this.deleteBankData, "confirmDelete");
    },
    closeConfirmModal() {
      this.triggerConfirmModal = false;
    },
    changeSuccess() {
      this.loading = true;
      const data = {
        categoryCode: this.currentCategoryCode,
        companyCode: this.companyCode,
        partnerId: this.partnerInfo.partnerId,
      };
      partnerService
        .quickLinkContactGetDataPage(data)
        .then((res) => {
          this.TaxContactDetails = res.response;
          this.loading = false;
          this.successModal = false;
        })
        .catch((e) => {
          this.getDocumentNumber();
          this.loading = false;
        });
      this.triggerModalWidget = false;
    },
    // closeTaxContactModal() {
    //   this.isEditContactClicked = false;
    //   this.editContact = [];
    //   this.triggerTaxContactModal=false;
    //   // location.reload();
    // },
    editContactDetail(contact) {
      if (contact.status == 4) {
        this.triggerModalWidget = true;
        this.alertModal = true;
        this.lastResponse =
          "The following contact is submitted for approval.Can't be edited.";
        return;
      }
      this.isEditContactClicked = true;
      this.editContact = contact;
      console.log("Edit Contact", this.editContact);
      this.triggerContactModal = true;
    },
    editTaxContactDetail(contact) {
      //this.triggerModalWidget = true;
      this.triggerTaxContactModal = true;
      this.isEditTaxContactClicked = true;
      this.editTaxContact = contact;
      //console.log("Edit Contact", this.editTaxContact);
    },
    editApprovedAddrDetails(addr) {
      this.isEditAddressClicked = true;
      this.editAddress = addr;
      console.log("Edit Address", this.editAddress);
      this.triggerAddressModal = true;
    },
    editApprovedStatutoryDetails(stat) {
      if (
        this.statutoryQLDetails.filter((x) => x && x.statusCode != 3).length > 0
      ) {
        window.alert(
          "Already a statutory update document is in workflow. Please refer table below."
        );
        return false;
      }
      this.isEditStatutoryClicked = true;
      this.editStatutory = stat;
      this.triggerStatutoryModal = true;
    },
    editStatutoryQLDetails(stat) {
      this.isEditStatutoryClicked = true;
      this.editStatutory = stat;
      this.triggerStatutoryModal = true;
    },
    // trackingStatus(contact) {
    //   this.loading = true;
    //   console.log(contact);
    //   if (contact.documentNo) {
    //     summaryService
    //       .getQuicklinkTrackingData(contact.documentNo)
    //       .then(resp => {
    //         if (resp.response) {
    //           this.loading = false;
    //           this.openTrackingModal = true;
    //           this.trackingDetails = resp.response.status;
    //           console.log("track ", this.trackingDetails);
    //           this.roleName = resp.response.evaluatorsName;
    //         } else {
    //           this.loading = false;
    //         }
    //       });
    //   }
    // },
    // trackingAnswerStatus(answer) {
    //   this.loading = true;
    //   console.log(answer);
    //   if (answer.answerNumber) {
    //     summaryService
    //       .getQuicklinkTrackingData(answer.answerNumber)
    //       .then(resp => {
    //         if (resp.response) {
    //           this.loading = false;
    //           this.openTrackingModal = true;
    //           this.trackingDetails = resp.response.status;
    //           this.roleName = resp.response.evaluatorsName;
    //         } else {
    //           this.loading = false;
    //         }
    //       });
    //   }
    // },
    closeTrackingModal() {
      this.openTrackingModal = false;
    },
    getCreatedDate(date) {
      return moment(date).format("DD-MMM-YYYY hh:mm A");
    },
    dottedTrackingStatus(status) {
      if (status == "Approved") {
        return "dottedGreen pl-2";
      }
      if (status == "Sendback") {
        return "dottedSendback";
      }
      if (status == "Rejected") {
        return "dottedRejected";
      }
      if (status == "Pending") {
        return "dottedPending";
      }
    },
    addMoreContact() {
      this.triggerContactModal = true;
    },
    addMoreAddress() {
      this.triggerAddressModal = true;
    },
    addMoreFinanceDetails() {
      this.loading = true;
      partnerService
        .getFinancialYearDropdown(this.currentCategoryCode, this.companyCode)
        .then((res) => {
          if (res.response) {
            this.loading = false;
            // this.UnfilledFinancialYear = res.response;
            this.triggerFinanceModal = true;
          } else {
            this.loading = false;
            this.triggerModalWidget = true;
            this.alertModal = true;
            this.lastResponse = "Financial year detail already added";
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    addMoreBankDetails() {
      this.triggerBankModal = true;
    },
    deleteContactCard(contact, value) {
      if (contact == null) {
        console.log("In DeleteContactCard function contact is null.");
        return;
      }
      if (contact.status == 4) {
        this.triggerModalWidget = true;
        this.alertModal = true;
        this.lastResponse =
          "The following contact is submitted for approval.Can't be deleted.";
        return;
      }
      this.deleteContactData = null;
      this.triggerConfirmModal = true;
      this.lastResponse = "Are you sure to delete your contact?";
      this.deleteContactData = contact;
      let contactDeleteRequest = {
        companyCode: "",
        categoryCode: "",
        slNo: "",
      };
      if (value == "confirmDelete") {
        this.triggerConfirmModal = false;
        this.loading = true;
        contactDeleteRequest.categoryCode = this.currentCategoryCode;
        contactDeleteRequest.companyCode = this.companyCode;
        contactDeleteRequest.slNo = this.deleteContactData.slNo;
        partnerService
          .deleteContact(contactDeleteRequest)
          .then((res) => {
            this.deleteContactData = null;
            this.triggerModalWidget = true;
            this.successModal = true;
            this.lastResponse = res.response;
            this.loading = false;
          })
          .catch((e) => {
            this.deleteContactData = null;
            this.alertModal = true;
            this.lastResponse =
              "Something Went Wrong!! Please Try Again Later.";
            this.loading = false;
          });
      }
    },
    deleteCertificateCard(answerList, value, status) {
      if (answerList == null) {
        return;
      }
      if (status == "C") {
        this.triggerModalWidget = true;
        this.alertModal = true;
        this.lastResponse =
          "The following certificate is submitted for approval.Can't be deleted.";
        return;
      }
      this.deleteCertificateData = null;
      this.triggerConfirmModal = true;
      this.lastResponse = "Are you sure to delete your certificate?";
      this.deleteCertificateData = answerList;
      if (value == "confirmDelete") {
        this.triggerConfirmModal = false;
        this.loading = true;
        let answers = [];
        answerList.forEach((element) => {
          answers.push(element.id);
        });
        let deleteCertificateRequest = {
          companyCode: "",
          categoryCode: "",
          answers: [],
        };
        deleteCertificateRequest.companyCode = this.companyCode;
        deleteCertificateRequest.categoryCode = this.currentCategoryCode;
        deleteCertificateRequest.answers = answers;
        partnerService
          .deleteCertificate(deleteCertificateRequest)
          .then((res) => {
            this.deleteCertificateData = null;
            this.triggerModalWidget = true;
            this.successModal = true;
            this.lastResponse = "Deleted Successfully";
            this.getGstDocumentDetails();
            this.getDocumentNumber();
            this.loading = false;
          })
          .catch((e) => {
            this.deleteCertificateData = null;
            this.loading = false;
          });
      }
    },
    editFinanceDetails(finance) {
      console.log("Parent edit finance clicked", finance);
      if (finance.statusCode == 4) {
        this.triggerModalWidget = true;
        this.alertModal = true;
        this.lastResponse =
          "The following finance detail is submitted for approval.Can't be edited.";
        return;
      }
      this.isEditFinanceClicked = true;
      this.editFinance = finance;
      this.triggerFinanceModal = true;
    },
    deleteFinanceDetail(finance, value) {
      if (finance == null) {
        return;
      }
      if (finance.statusCode == 4) {
        this.triggerModalWidget = true;
        this.alertModal = true;
        this.lastResponse =
          "The following finance detail is submitted for approval.Can't be deleted.";
        return;
      }
      this.deleteFinanceData = null;
      this.triggerConfirmModal = true;
      this.lastResponse = "Are you sure to delete your finance detail?";
      this.deleteFinanceData = finance;
      if (value == "confirmDelete") {
        this.triggerConfirmModal = false;
        this.loading = true;
        let deleteFinanceDetailRequest = {
          companyCode: "",
          categoryCode: "",
          financeYear: "",
        };
        deleteFinanceDetailRequest.companyCode = this.companyCode;
        deleteFinanceDetailRequest.categoryCode = this.currentCategoryCode;
        deleteFinanceDetailRequest.financeYear = finance.financeYear;
        partnerService
          .deleteFinanceDetail(deleteFinanceDetailRequest)
          .then((res) => {
            this.deleteFinanceData = null;
            this.triggerModalWidget = true;
            this.successModal = true;
            this.lastResponse = "Deleted Successfully";
            this.getGstDocumentDetails();
            this.getDocumentNumber();
            this.loading = false;
            // this.getUnfilledFinancialYear();
          })
          .catch((e) => {
            this.deleteFinanceData = null;
            this.loading = false;
          });
      }
    },
    deleteBankDetail(bank, value) {
      if (bank == null) {
        return;
      }
      if (bank.statusCode == 4) {
        this.triggerModalWidget = true;
        this.alertModal = true;
        this.lastResponse =
          "The following bank detail is submitted for approval. Can't be deleted.";
        return;
      }
      if (bank.statusCode == 1 && bank.accountCategory == "Primary") {
        this.triggerModalWidget = true;
        this.alertModal = true;
        this.lastResponse =
          "The following bank detail is approved primary bank. It can't be deleted.";
        return;
      }
      this.deleteBankData = null;
      this.triggerConfirmModal = true;
      this.lastResponse = "Are you sure to delete your bank detail?";
      this.deleteBankData = bank;
      if (value == "confirmDelete") {
        this.triggerConfirmModal = false;
        this.loading = true;
        let deleteBankDetailRequest = {
          companyCode: "",
          categoryCode: "",
          slNo: "",
        };
        deleteBankDetailRequest.companyCode = this.companyCode;
        deleteBankDetailRequest.categoryCode = this.currentCategoryCode;
        deleteBankDetailRequest.slNo = bank.slNo;

        deleteBankDetailRequest.statusCode = bank.statusCode;
        deleteBankDetailRequest.accountCategory =
          bank.accountCategory.charAt(0);

        partnerService
          .deleteBankDetail(deleteBankDetailRequest)
          .then((res) => {
            if (res.failureMessage == "") {
              this.deleteBankData = null;
              this.triggerModalWidget = true;
              this.successModal = true;
              this.lastResponse = "Deleted Successfully";
              this.getGstDocumentDetails();
              this.getDocumentNumber();
              this.loading = false;
            } else {
              window.alert(res.failureMessage);
            }
          })
          .catch((e) => {
            this.deleteBankData = null;
            this.loading = false;
          });
      }
    },
    editBankDetails(bankDetail) {
      var isSendbackEdit = this.quickLinkDetails.bankDetails.filter(
        (x) => x.statusCode == 2 && x.accountCategory == "Primary"
      );
      if (bankDetail.statusCode == 1 && isSendbackEdit.length > 0) {
        window.alert(
          "Please edit primary sentback document based on remarks and re submit"
        );

        return false;
      }
      var isSendbackEdit = this.quickLinkDetails.bankDetails.filter(
        (x) => x.statusCode == 7 && x.accountCategory == "Primary"
      );
      if (bankDetail.statusCode == 1 && isSendbackEdit.length > 0) {
        window.alert("Please edit already created primary document and submit");

        return false;
      }

      if (bankDetail.statusCode == 4) {
        this.triggerModalWidget = true;
        this.alertModal = true;
        this.lastResponse =
          "The following Bank detail is submitted for approval.Can't be edited.";
        return;
      }
      this.isEditBankClicked = true;
      this.editBank = bankDetail;
      this.triggerBankModal = true;
    },
    addMore(question) {
      this.quickLinkDescription = question.quickLinkDescription;
      console.log("addMore function is called.");

      this.questionCode = question.questionCode;
      // console.log(question.answerList[0][0].id.moduleCode);
      if (question.answerList && question.answerList.length > 0) {
        this.moduleCode = question.answerList[0].answer[0].id.moduleCode;
        this.answerNumber = question.answerList[0].answer[0].id.answerNumber;
        this.loading = true;
        partnerService
          .getQuickLinkQuestions(
            this.questionCode,
            this.moduleCode,
            this.answerNumber
          )
          .then((res) => {
            this.loading = false;
            this.questionList = res.response;
            this.triggerModalcert = true;
            console.log("questionList", this.questionList);
          })
          .catch((e) => {
            this.loading = false;
            this.lastResponse = "Try again later.";
            this.triggerModalWidget = true;
            console.error(e);
          });
      } else {
        //  this.loading = true;
        //    partnerService
        //       .getQuicklikFirstQuestion(this.currentCategoryCode)
        //      .then(resp => {
        //       resp.response.forEach(data => {
        //       if (data.questionCode == this.questionCode) {
        //           partnerService
        //            .getQuickLinkQuestions(
        //              this.questionCode,
        //              data.moduleCode,
        //              data.answerNumber
        // //            )
        //          .then(resp => {
        //            this.loading = false;
        //          this.questionList = resp.response;
        //         this.triggerModal = true;
        //           console.log("questionList", this.questionList);
        //       })
        //       .catch(e => {
        //           this.loading = false;
        //        this.lastResponse = "Try again later.";
        //         this.triggerModalWidget = true;
        //         console.error(e);
        //      });
        //   }
        //  });
        // this.triggerModal = true;
        //    console.log("questionList", this.questionList);
        //  })
        //   .catch(e => {
        //   this.loading = false;
        //    this.lastResponse = "Try again later.";
        //   this.triggerModalWidget = true;
        //    console.error(e);
        //   });
      }
    },
    editCard(answerList, question, status) {
      if (status == "C") {
        this.triggerModalWidget = true;
        this.alertModal = true;
        this.lastResponse =
          "The following certificate is submitted for approval.Can't be edited.";
        return;
      }
      this.quickLinkDescription = question.quickLinkDescription;
      console.log("edit function is called.", answerList);
      this.isEditClicked = true;
      // this.triggerModal = true;
      this.editAnswers = answerList;
      this.loading = true;
      this.questionCode = question.questionCode;
      this.moduleCode = question.answerList[0].answer[0].id.moduleCode;
      this.answerNumber = question.answerList[0].answer[0].id.answerNumber;
      partnerService
        .getQuickLinkQuestions(
          this.questionCode,
          this.moduleCode,
          this.answerNumber
        )
        .then((res) => {
          this.loading = false;
          this.questionList = res.response;
          this.triggerModalcert = true;
          // console.log("questionList", this.questionList);
        })
        .catch((e) => {
          this.loading = false;
          this.lastResponse = "Try again later.";
          this.triggerModalWidget = true;
          console.error(e);
        });
    },
    closeModal() {
      this.questionList = [];
      this.triggerModalcert = false;
      this.isEditClicked = false;
      this.openModal = false;
    },
    showAttachFile(event) {
      this.loading = true;
      OnBoardingService.downLoadDocument(event)
        .then((res) => {
          this.loading = false;
        })
        .catch((e) => {
          this.loading = false;
        });
    },

    getGSTAttachment(event) {
      this.loading = true;
      this.formChanged = true;
      console.log(event[0]);
      let data = new FormData();
      let file = event[0];
      console.log(file);
      // data.append("name", "my-file");
      data.append("file", file);
      OnBoardingService.uploadAttachments(data).then((resp) => {
        this.loading = false;
        if (resp) {
          this.form.gstDocumentId = resp.UniqueID;
          this.form.siteUrl = resp.SiteUrl;
        }
      });
    },
    dottedStatus(status) {
      if (status == "A" || status == 1) {
        return "dottedGreen";
      }
      if (status == "S" || status == 2) {
        return "dottedSendback";
      }
      if (status == "R" || status == 3) {
        return "dottedRejected";
      }
      if (status == "C" || status == 4) {
        return "dottedPending";
      }
      if (status == "N" || status == 7) {
        return "dottedCreated";
      }
    },
    getDocumentNumber() {
      partnerService
        .quicklinkDocumentNumber(this.companyCode, this.currentCategoryCode)
        .then((resp) => {
          if (resp.response) {
            this.documentNumber = resp.response;
            console.log(this.documentNumber);
            this.isSubmitDisable = false;
          } else if (resp.failureMessage == "Document Not Generated") {
            this.isSubmitDisable = true;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    checkSubmit() {
      if (this.companyCode && this.currentCategoryCode) {
        partnerService
          .quicklinkDocumentNumber(this.companyCode, this.currentCategoryCode)
          .then((resp) => {
            if (resp.failureMessage == "Document Not Generated") {
              // alert(true);
              this.isSubmitDisable = true;
              return true;
            } else {
              // alert(false);
              this.isSubmitDisable = false;
              return false;
            }
          })
          .catch((err) => {});
      }
    },
    selectedStatusDetails(code, codeType, styleName) {
      this.selectedStatusFilter = codeType;
      this.selectedStatusFilterCode = code;
      this.activeStatusStyle = styleName; /* 
      this.quickLinkDetails.contacts = this.quickLinkContactDetails;
      let temp1 = [];
      for (let i = 0; i < this.quickLinkDetails.contacts.length; i++) {
        if (this.quickLinkDetails.contacts[i].status == code) {
          temp1.push(this.quickLinkDetails.contacts[i]);
        }
      }
      this.isContact = temp1.length == 0 ? false : true;
      this.quickLinkDetails.financeDetails = this.quickLinkFinanceDetails;
      let temp3 = [];
      for (let i = 0; i < this.quickLinkDetails.financeDetails.length; i++) {
        if (this.quickLinkDetails.financeDetails[i].statusCode == code) {
          temp3.push(this.quickLinkDetails.financeDetails[i]);
        }
      }
      //this.isContact = temp3.length == 0 ? false : true;
      this.quickLinkDetails.financeDetails = temp3;

      this.quickLinkDetails.bankDetails = this.quickLinkBankDetails;
      let temp4 = [];
      for (let i = 0; i < this.quickLinkDetails.bankDetails.length; i++) {
        if (this.quickLinkDetails.bankDetails[i].statusCode == code) {
          temp4.push(this.quickLinkDetails.bankDetails[i]);
        }
      }
      //this.isContact = temp3.length == 0 ? false : true;
      this.quickLinkDetails.bankDetails = temp4;
      this.isAddMoreDisabled = true;
      this.quickLinkDetails.contacts = temp1;
      this.quickLinkDetails.answer[0].answerList = this.quickLinkAnswerDetails;
      for (let j = 0; j < this.quickLinkDetails.answer.length; j++) {
        let temp2 = [];
        for (
          let i = 0;
          i < this.quickLinkDetails.answer[j].answerList.length;
          i++
        ) {
          if (
            this.quickLinkDetails.answer[0].answerList[i].status == codeType
          ) {
            temp2.push(this.quickLinkDetails.answer[0].answerList[i]);
          }
        }
        this.quickLinkDetails.answer[j].answerList = temp2;
        this.isAnswer = temp2.length == 0 ? false : true;
      } */
    },
    allDataDisplay(styleName) {
      this.activeStatusStyle = styleName;
      this.quickLinkDetails.contacts = this.quickLinkContactDetails;
      this.isContact =
        this.quickLinkDetails.contacts.length == 0 ? false : true;
      for (let j = 0; j < this.quickLinkDetails.answer.length; j++) {
        this.quickLinkDetails.answer[j].answerList =
          this.quickLinkAnswerDetails;
        this.isAnswer =
          this.quickLinkDetails.answer[j].answerList.length == 0 ? false : true;
      }
      this.quickLinkDetails.financeDetails = this.quickLinkFinanceDetails;
      this.isContact =
        this.quickLinkDetails.financeDetails.length == 0 ? false : true;

      this.quickLinkDetails.bankDetails = this.quickLinkBankDetails;
      this.isContact =
        this.quickLinkDetails.bankDetails.length == 0 ? false : true;
      this.isAddMoreDisabled = false;
    },
    ConfirmSubmitForTechApproval() {
      var self = this;
      var r = window.prompt(
        "Are you sure you want submit for technical approval? Provide remarks if any (not mandatory) and click ok",
        ""
      );
      if (r != null && r.length < 500) {
        self.submitForTechnicalApproval(r);
      } else if (r.length >= 500) {
        window.alert("Remarks cannot be more than 500 characters!");
      } else {
        txt = "You pressed Cancel!";
      }
    },
    ConfirmSubmitForFinApproval() {
      var self = this;
      var r = window.prompt(
        "Are you sure you want submit for financial approval? Provide remarks if any (not mandatory) and click ok",
        ""
      );
      if (r != null && r.length < 500) {
        self.submitForFinancialApproval(r);
      } else if (r.length >= 500) {
        window.alert("Remarks cannot be more than 500 characters!");
      } else {
        txt = "You pressed Cancel!";
      }
    },
    submitForTechnicalApproval(remarks) {
      let data = {
        actionStatus: 4,
        userId: this.partnerInfo.userId,
        categoryCode: this.currentCategoryCode,
        companyCode: this.companyCode,
        remarks: remarks,
      };
      this.loading = true;
      partnerService
        .quicklinkApproval(data)
        .then((resp) => {
          this.refreshDataAfterSubmit();
          if (resp.failureMessage == "") {
            this.loading = false;
            this.triggerModalWidget = true;
            this.successModal = true;
            this.lastResponse = resp.response;
            this.checkSubmit();
          } else {
            this.loading = false;
            this.triggerModalWidget = true;
            this.alertModal = true;
            this.checkSubmit();
            this.lastResponse = resp.failureMessage;
          }
        })
        .catch((err) => {
          this.refreshDataAfterSubmit();
          this.loading = false;
          this.triggerModalWidget = true;
          this.alertModal = true;
          this.lastResponse = "Something went wrong, Please try again later";
        });
    },

    getpartnerDetails() {
      partnerService.getPartnerInfo().then((resp) => {
        this.partnerDetailInfo = resp.response;
        this.$root.isInternational =
          resp.response.countryDetail.countryCode == 100 ? false : true;
        this.companycode = resp.response.currentCompanyCode;
        this.companyCode = resp.response.currentCompanyCode;
        this.categoryCode = resp.response.currentCategoryCode;
        this.getGSTState();
        this.getGstDealers();
        this.getBusinessCategory();

        //this.getBusinessCategoryValue();
        //this.getBusinessSubCategoryValue();
        this.getGstTableView();
        this.getGstPendingDetails();
        //this.getGstDocumentNumber();
        this.getGstDocumentDetails();
      });
    },
    getGstPendingDetails() {
      partnerService.getPendingGstDetails(this.companycode).then((resp) => {
        if (resp.response) {
          this.loading = false;
          this.listOfPendingGST = resp.response
            .filter((x) => x.statusCode != 3)
            .map((y) => y.gstinNumber);
          this.dontShowApprovedList = true;
          this.gstPendingTableDataList.items = resp.response;
          this.tempGstPendingDetails = resp.response;
          this.gstcreatedCount = 0;
          this.gstpendingCount = 0;
          this.gstsentbackCount = 0;
          this.gstrejectedCount = 0;
          for (let i = 0; i < this.gstPendingTableDataList.items.length; i++) {
            if (
              this.gstPendingTableDataList.items[i].statusCode == 7 ||
              this.gstPendingTableDataList.items[i].statusCode == "N"
            ) {
              this.gstcreatedCount += 1;
            } else if (
              this.gstPendingTableDataList.items[i].statusCode == 4 ||
              this.gstPendingTableDataList.items[i].statusCode == "C"
            ) {
              this.gstpendingCount += 1;
            } else if (
              this.gstPendingTableDataList.items[i].statusCode == 3 ||
              this.gstPendingTableDataList.items[i].statusCode == "R"
            ) {
              this.gstrejectedCount += 1;
            } else {
              this.gstsentbackCount += 1;
            }
          }
        } else {
          this.loading = false;
          this.dontShowApprovedList = false;
        }
      });
    },
    getGstTableView() {
      partnerService.getApprovedGstDetails(this.companycode).then((resp) => {
        if (resp.response) {
          this.listOfApprovedGST =
            resp.response.gstInList != null
              ? resp.response.gstInList
                  .filter((x) => x.statusCode != 3)
                  .map((y) => y.gstinNumber)
              : [];
          this.gstTableDataList.items = resp.response.gstInList;
          if (this.gstTableDataList.items != null) {
            this.gstTableDataList.items.forEach(function (obj) {
              if (obj.isValid == "N") {
                obj.isValid = "No";
              }
              if (obj.isValid == "Y") {
                obj.isValid = "Yes";
              }
              if (obj.isActive == "N") {
                obj.isActive = "No";
              }
              if (obj.isActive == "Y") {
                obj.isActive = "Yes";
              }
            });
          }
          this.loading = false;
        } else {
          this.loading = false;
        }
      });
    },
    refreshDataAfterSubmit() {
      this.getDocumentNumber();
      this.getGstDocumentDetails();
      this.refreshPQL();
      this.getGstTableView();
      this.getGstPendingDetails();
      this.getPartnerApprovedBusinessCategory();
      this.getPartnerNotApprovedBusinessCategory();
      this.getAddressTabData();
      this.getStatutoryTabData();
    },
    addGstDetails() {
      this.emptyForm();
      this.selected = "";
      this.editModal = false;
      this.openModal = true;
      this.approvedEditList = false;
    },
    closeTriggerdModal() {
      this.triggerModal = false;
      this.alertModal = false;
      this.successModal = false;
      //this.getGstDocumentDetails();
    },
    emptyForm() {
      this.form.SlNo = null;
      this.form.categoryCode = null;
      this.form.subCategoryCode = null;
      this.form.companyCode = null;
      this.form.dealerTypeCode = null;
      this.form.stateCode = null;
      this.form.thresholdTurnoverLimit = null;
      this.form.gstEffectiveFrom = null;
      this.form.gstEffectiveUpto = null;
      this.form.gstNumber = null;
      this.form.gstRegistrationDate = null;
      this.form.originCountryCode = null;
      this.form.originStateCode = null;
      this.form.registrationDate = null;
      this.form.registrationNumber = null;
      this.form.registrationType = null;
      this.form.effectiveFrom = null;
      this.form.effectiveUpto = null;
      this.form.workCountryCode = 100;
      this.form.workStateCode = null;
      this.selectedDateRange = [];
      this.disableDateBefore = "";
      this.disableDateAfter = "";
      this.validityTimePeriod = [];
      this.gstDuplicate = false;
    },
    triggerApprovedEditGstModal(event) {
      partnerService
        .editApprovedGstList(this.companycode, event.slno)
        .then((resp) => {
          this.form = resp.response;
          this.form.slNo = event.slno;
          this.selected = resp.response.registrationType;
          // this.selectedDateRange = [];
          // this.selectedDateRange.push(
          //   resp.response.gstEffectiveFrom,
          //   resp.response.gstEffectiveUpto
          // );
          if (
            resp.response.dealerTypeCode == 3 ||
            resp.response.dealerTypeCode == 4
          ) {
            this.getCountryList();
            this.getGstOrginState(resp.response.originCountryCode);

            if (resp.response.effectiveFrom) {
              // this.validityTimePeriod = [];
              // this.validityTimePeriod.push(
              //   resp.response.effectiveFrom,
              //   resp.response.effectiveUpto
              // );
            }
          }
          this.$forceUpdate();
          this.openModal = true;
          this.editModal = true;
          this.approvedEditList = true;
        });
    },
    // trackingStatus(event) {
    //   console.log(event);
    //   this.loading = false;
    //   console.log(event);
    //   if (event.documentNo) {
    //     summaryService.getQuicklinkTrackingData(event.documentNo).then(resp => {
    //       if (resp.response) {
    //         this.loading = false;
    //         this.openTrackingModal = true;
    //         this.trackingDetails = resp.response.status;
    //         this.roleName = resp.response.evaluatorsName;
    //       } else {
    //         this.loading = false;
    //       }
    //     });
    //   }
    // },
    closeTrackingModal() {
      this.openTrackingModal = false;
    },
    getCreatedDate(date) {
      return moment(date).format("DD-MMM-YYYY hh:mm A");
    },
    dottedStatus(status) {
      if (status == "Approved") {
        return "dottedGreen";
      }
      if (status == "Sendback") {
        return "dottedSendback";
      }
      if (status == "Rejected") {
        return "dottedRejected";
      }
      if (status == "Pending") {
        return "dottedPending";
      }
    },
    triggerEditGstModal(event) {
      if (event.statusCode == 4) {
        this.triggerModal = true;
        this.alertModal = true;
        this.lastResponse =
          "The following GST detail is submitted for approval.Can't be edited.";
        return;
      }
      partnerService
        .editGstDetails(this.companycode, event.slno)
        .then((resp) => {
          this.form = resp.response;
          this.form.slNo = event.slno;
          this.gstEditDocNo = event.documentNo;
          this.selected = resp.response.registrationType;
          if (this.selcted == "V") {
            this.getBusinessSubCategory(resp.response.categoryCode);
          }
          // this.selectedDateRange = [];
          // this.selectedDateRange.push(
          //   resp.response.gstEffectiveFrom,
          //   resp.response.gstEffectiveUpto
          // );
          if (
            resp.response.dealerTypeCode == 3 ||
            resp.response.dealerTypeCode == 4
          ) {
            this.getCountryList();
            this.getGstOrginState(resp.response.originCountryCode);

            if (resp.response.effectiveFrom) {
              // this.validityTimePeriod = [];
              // this.validityTimePeriod.push(
              //   resp.response.effectiveFrom,
              //   resp.response.effectiveUpto
              // );
            }
          }
          this.$forceUpdate();
          this.openModal = true;
          this.editModal = true;
        });
    },
    clickedSearch() {
      this.partnerDetailsFilterText =
        this.partnerDetailsFilterText.toUpperCase();
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    getBusinessCategory() {
      partnerService.getGstCategories(this.companycode).then((resp) => {
        if (resp.response) {
          resp.response.forEach((data) => {
            this.businessCategory.push({
              text: data.longDesc,
              value: data.categoryCode,
            });
          });
        }
      });
    },
    getBusinessSubCategory(code) {
      this.businessSubCategory = [];
      partnerService
        .getGstSubCategories(code, this.companycode)
        .then((resp) => {
          if (resp.response) {
            resp.response.forEach((data) => {
              this.businessSubCategory.push({
                text: data.longDesc,
                value: data.categoryCode,
              });
            });
          }
        });
    },

    getGSTState() {
      partnerService
        .getStatesForGST(100)
        .then((resp) => {
          if (resp.response) {
            resp.response.forEach((element) => {
              this.gststatelist.push({
                text: element.longDescr,
                value: element.stateCode,
              });
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getGstDealers() {
      partnerService
        .gstDealers()
        .then((resp) => {
          if (resp.response) {
            resp.response.forEach((element) => {
              this.gstDealersDropDown.push({
                text: element.longDesc,
                value: element.dealerTypeCode,
              });
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getBusinessCategoryValue(event) {
      //this.form.businessTypeCode = event;
      this.form.categoryCode = event;
      this.getBusinessSubCategory(event);
    },
    getBusinessSubCategoryValue(event) {
      //this.form.businessTypeCode = event;
      this.form.subCategoryCode = event;
    },

    getGstNumber(event) {
      this.form.gstNumber = event.toUpperCase();
      if (event.length > 14) {
        OnBoardingService.checkGSTNumber(event).then((resp) => {
          if (resp.failureMessage == "Not Available") {
            this.gstDuplicate = true;
          }
        });
      } else {
        this.gstDuplicate = false;
      }
    },
    getGstRegisterNumber(event) {
      this.form.registrationNumber = event;
    },
    getGSTRegisterDate(event) {
      this.disableDateBefore = "";
      this.disableDateAfter = "";
      this.form.gstRegistrationDate = event;
      this.disableDateBefore = event;
      // var oneYearFromNow = new Date();
      // this.disableDateAfter = oneYearFromNow.setFullYear(
      //   oneYearFromNow.getFullYear() + 3
      // );
      // this.selectedDateRange = "";
      // this.form.gstEffectiveFrom = null;
      // this.form.gstEffectiveUpto = null;
    },
    getGSTEffectiveFromDate(event) {
      this.disableDateBefore = "";
      this.disableDateAfter = "";
      this.form.gstEffectiveFrom = event;
      this.disableDateBefore = event;   
      // this.form.gstEffectiveFrom = event.toLocaleDateString();
    },
    topFunction() {
      $(".modal-body").scrollTop(0);
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
    getRegisterDate(event) {
      this.gstDisableDateBefore = "";
      this.gstDisableDateAfter = "";
      this.form.registrationDate = event;
      // this.gstDisableDateBefore = event;
      // var oneYearFromNow = new Date();
      // this.gstDisableDateAfter = oneYearFromNow.setFullYear(
      //   oneYearFromNow.getFullYear() + 3
      // );
      // this.validityTimePeriod = "";
      // this.form.effectiveFrom = null;
    },
    getEffectiveTimeFrom(event) {
      this.form.effectiveFrom = event.toLocaleDateString();
    },
    // gstEffectiveDate(event) {
    //   this.selectedDateRange = event;
    //   this.form.gstEffectiveFrom = event[0].toLocaleDateString();
    //   this.form.gstEffectiveUpto = event[1].toLocaleDateString();
    // },
    // gstEffectiveTimePeriod(event) {
    //   this.validityTimePeriod = event;
    //   this.form.effectiveFrom = event[0].toLocaleDateString();
    //   this.form.effectiveUpto = event[1].toLocaleDateString();
    // },
    getResgisteredGstState(event) {
      this.form.stateCode = event;
    },
    getTurnOver(event) {
      this.form.thresholdTurnoverLimit = event;
    },
    getGstDealersType(event) {
      this.form.dealerTypeCode = event;
      if (event == 3 || event == 4) {
        this.getCountryList();
      }
    },
    getCountryList() {
      partnerService
        .getGstCountry()
        .then((resp) => {
          if (resp.response) {
            resp.response.forEach((element) => {
              if (element.countryCode != 100) {
                this.countryDropDown.push({
                  text: element.longDesc,
                  value: element.countryCode,
                });
              }
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getWorkRegisteredCountry(event) {
      this.getGstOrginState(event);
      this.form.originCountryCode = event;
      this.form.originStateCode = null;
    },
    getGstOrginState(event) {
      this.gstStateDropDown = [];
      partnerService
        .getStatesForGST(event)
        .then((resp) => {
          if (resp.response) {
            resp.response.forEach((element) => {
              this.gstStateDropDown.push({
                text: element.longDescr,
                value: element.stateCode,
              });
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getWorkResgisteredGstState(event) {
      this.form.originStateCode = event;
    },
    getGstWorkState(event) {
      this.form.workStateCode = event;
    },
    checkValidation() {
      if (
        this.form.stateCode &&
        this.form.thresholdTurnoverLimit &&
        this.form.gstEffectiveFrom &&
        this.form.gstNumber &&
        this.form.dealerTypeCode
      ) {
        if (this.form.dealerTypeCode == 3 || this.form.dealerTypeCode == 4) {
          if (
            this.form.effectiveFrom &&
            this.form.registrationNumber &&
            this.form.registrationDate &&
            this.form.workStateCode &&
            this.form.originCountryCode &&
            this.form.originStateCode
          ) {
            return false;
          } else {
            return true;
          }
        } else {
          return false;
        }
      } else {
        return true;
      }
    },

    saveGstDetails(saveType, approvedType) {
      this.form.registrationType = this.selected;
      if (!this.form.registrationType) {
        this.dismissCountDown = this.dismissSecs;
        this.errorMessage = "Please select your registration Type";
        this.topFunction();
        return;
      }
      if (this.form.registrationType == "V") {
        if (this.form.categoryCode == null) {
          this.dismissCountDown = this.dismissSecs;
          this.errorMessage = "Select your Business Category";
          this.topFunction();
          return;
        }
        if (this.form.subCategoryCode == null) {
          this.dismissCountDown = this.dismissSecs;
          this.errorMessage = "Select your Bussiness Sub-Category";
          this.topFunction();
          return;
        }
      }
      if (this.form.stateCode == this.form.workStateCode) {
        this.dismissCountDown = this.dismissSecs;
        this.errorMessage = "GST State and Work state cannot be same";
        this.form.workStateCode = null;
        this.topFunction();
        return;
      }
      if (this.gstDuplicate == true) {
        this.dismissCountDown = this.dismissSecs;
        this.errorMessage = "Please check the GST number";
        this.topFunction();
        return;
      }
      if (this.form.gstDocumentId == "") {
        this.dismissCountDown = this.dismissSecs;
        this.errorMessage = "Please attach GST certificate";
        this.topFunction();
        return;
      }

      /*if (this.form.gstRegistrationDate.setHours(0,0,0,0) > this.form.gstEffectiveFrom.setHours(0,0,0,0)) {
        this.dismissCountDown = this.dismissSecs;
        this.errorMessage = "GST Effective from cannot be before GST registration date ";
        this.topFunction();
        return;        
      }*/

      if (
        !this.editModal &&
        (this.listOfApprovedGST.indexOf(this.form.gstNumber) > -1 ||
          this.listOfPendingGST.indexOf(this.form.gstNumber) > -1)
      ) {
        this.dismissCountDown = this.dismissSecs;
        window.alert(
          "GST number " +
            this.form.gstNumber +
            " is already in the existing list"
        );
        this.topFunction();
        return;
      }

      this.form.companyCode = this.companycode;

      this.loading = true;
      partnerService.gstNumberVerification(this.form.gstNumber).then((res) => {
        if (res.response) {
          // SAVE GST DETAILS
          // this.loading = true;
          console.log(this.form);
          if (saveType != true) {
            partnerService
              .saveGstDetail(this.form)
              .then((resp) => {
                if (resp.response) {
                  this.loading = false;
                  this.openModal = false;
                  this.triggerModal = true;
                  this.successModal = true;
                  this.lastResponse = resp.response;
                  this.getGstPendingDetails();
                  this.getGstDocumentDetails();
                } else {
                  this.loading = false;
                  this.triggerModal = true;
                  this.alertModal = true;
                  this.lastResponse = resp.failureMessage;
                }
              })
              .catch((e) => {
                this.loading = false;
              });
          } else {
            // EDIT GST DETAILS
            if (approvedType) {
              this.form.documentNumber = this.gstEditDocNo;
              partnerService
                .updateApprovedGstDetails(this.form)
                .then((resp) => {
                  if (resp.response) {
                    this.loading = false;
                    this.openModal = false;
                    this.triggerModal = true;
                    this.successModal = true;
                    this.lastResponse = resp.response;
                    this.getGstPendingDetails();
                    this.getGstDocumentDetails();
                  } else {
                    this.triggerModal = true;
                    this.loading = false;
                    this.alertModal = true;
                    this.lastResponse = resp.failureMessage;
                  }
                })
                .catch((e) => {
                  this.loading = false;
                });
            } else {
              this.form.documentNumber = this.gstEditDocNo;
              partnerService
                .updateGSTDetail(this.form)
                .then((resp) => {
                  if (resp.response) {
                    this.loading = false;
                    this.openModal = false;
                    this.triggerModal = true;
                    this.successModal = true;
                    this.lastResponse = resp.response;
                    this.getGstPendingDetails();
                    this.getGstDocumentDetails();
                  } else {
                    this.triggerModal = true;
                    this.loading = false;
                    this.alertModal = true;
                    this.lastResponse = resp.failureMessage;
                  }
                })
                .catch((e) => {
                  this.loading = false;
                });
            }
          }
        } else {
          this.loading = false;
          this.triggerModal = true;
          this.successModal = false;
          this.alertModal = true;
          this.lastResponse = res.failureMessage;
        }
      });
    },
    getGstDocumentDetails() {
      partnerService
        .gstDocumentNumber(this.companycode, this.currentCategoryCode)
        .then((resp) => {
          if (resp.failureMessage != "Document Not Generated") {
            this.gstDocumentNumber = resp.response;
            this.gstButtonEnable = false; // revert back false is correct.  -comment to do
          } else if (resp.failureMessage == "Document Not Generated") {
            this.gstButtonEnable = true;
          }
          this.$forceUpdate();
        });
    },

    // getGstDocumentNumber() {
    //   partnerService.partnerGstDocumentNo(0, this.companycode).then(resp => {
    //     if (resp.response) {
    //       this.gstActionStatus = resp.response.status;
    //       // this.gstDocumentNumber = resp.response.answerNumber;
    //     } else {
    //       this.gstActionStatus = resp.failureMessage;
    //     }
    //   });
    // },
    disabledSubmit(status) {
      if (status == "N" || status == "No Status") {
        return false;
      } else {
        return true;
      }
    },
    submitForFinancialApproval(remarks) {
      let data = {
        actionStatus: 4,
        userId: this.partnerInfo.userId,
        categoryCode: this.currentCategoryCode,
        companyCode: this.companyCode,
        remarks: remarks,
      };
      this.loading = true;
      partnerService
        .gstApproval(data)
        .then((resp) => {
          this.refreshDataAfterSubmit();
          if (resp.failureMessage == "") {
            this.loading = false;
            this.triggerModal = true;
            this.successModal = true;
            this.lastResponse = resp.response;
            this.getGstPendingDetails();
          } else {
            this.loading = false;
            this.triggerModal = true;
            this.alertModal = true;
            this.lastResponse = resp.failureMessage;
          }
        })
        .catch((err) => {
          this.refreshDataAfterSubmit();
          this.loading = false;
          this.triggerModal = true;
          this.alertModal = true;
          this.lastResponse = "Something went wrong,Please try again later";
        });
    },
    GstByStatus(statusCode, statusType) {
      this.gstPendingTableDataList.items = [];
      for (let i = 0; i < this.tempGstPendingDetails.length; i++) {
        if (
          this.tempGstPendingDetails[i].statusCode == statusCode ||
          this.tempGstPendingDetails[i].statusCode == statusType
        ) {
          this.gstPendingTableDataList.items.push(
            this.tempGstPendingDetails[i]
          );
        }
      }
    },
  },
};
</script>
<style scoped>
.my-custom-scrollbar {
  max-height: 300px;
  width: 100%;
  font-family: "Source Sans Pro", sans-serif;
  overflow: auto;
}
.my-custom-scrollbar thead th {
  position: sticky;
  top: 0;
}
.btn-border:focus {
  outline: none;
}
.certificate-card:hover {
  box-shadow: 10px 20px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);
}
.title {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 24px;
  font-weight: 600;
  text-align: left;
}
.inner-title {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 14px;
  font-weight: bold;
  text-align: left;
}
.nav-link {
  font-family: SourceSansProSemiBold;
  font-size: 12px;
  font-weight: 600;
  text-align: left;
  color: #0e5d84;
}
.certificate-card {
  /* height: 270px; */
  width: 75% !important;
  background-color: #f7f8fa;
}
.contact-card {
  width: 75% !important;
  background-color: #f7f8fa;
}
.contact-card:hover {
  box-shadow: 10px 20px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);
}
.diplay-heading {
  font-size: 11px;
  font-weight: 600;
  text-align: left;
  font-family: "SourceSansProSemiBold", sans-serif;
  color: #0e5d84;
}
.answer-heading {
  /* padding: 0; */
  font-size: 13px;
  text-align: left;
  font-family: "Source Sans Pro", sans-serif;
  color: var(--black);
}
.add-button {
  text-align: left;
  font-family: "Source Sans Pro", sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #0e5d84;
}
.delete-card ml-auto {
  float: right;
}
.scroll-card {
  overflow: auto;
  white-space: nowrap;
}

.dottedCreated {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: orange;
  float: left;
  margin-top: 7%;
}
.dottedGreen {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #28b915;
  float: left;
  margin-top: 1%;
}
.dottedPending {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #f4cf08;
  float: left;
  margin-top: 7%;
}
.dottedRejected {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #e61313;
  float: left;
  margin-top: 3%;
}
.dottedSendback {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #002d72;
  float: left;
  margin-top: 3%;
}
.table thead th {
  vertical-align: bottom;
  border-bottom: 2px solid #d0d3d6;
  background-color: #6192b1;
  position: sticky !important;
  color: #fff;
  text-align: left;
}
.button-class {
  width: 160px;
  height: 50px;
  font-family: "Source Sans Pro", sans-serif;
  font-size: 14px;
  line-height: 1.29;
  text-align: center;
  color: white !important;
  border-radius: 2px;
  background-color: #1579ab;
  margin-bottom: 30px;
}
.sumbit-approval {
  background-color: #0e5d84;
  font-size: 14px;
  font-weight: 600;
  color: #ffffff !important;
  border-color: none !important;
}
.action-text {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 15px;
  color: #939393;
}
.orange-dot,
.Created {
  height: 10px;
  width: 10px;
  background-color: orange;
  border-radius: 50%;
  display: inline-block;
}
.red-dot,
.Rejected {
  height: 10px;
  width: 10px;
  background-color: #f43b3b;
  border-radius: 50%;
  display: inline-block;
}
.yellow-dot,
.Pending {
  height: 10px;
  width: 10px;
  background-color: #f4cf08;
  border-radius: 50%;
  display: inline-block;
}
.blue-dot,
.SendBack,
.Sendback {
  height: 10px;
  width: 10px;
  border-radius: 50%;
  display: inline-block;
  background-color: #002d72;
}
.green-dot,
.Approved {
  height: 10px;
  width: 10px;
  border-radius: 50%;
  display: inline-block;
  background-color: #28b915;
}
.Not-Certified {
  height: 10px;
  width: 10px;
  border-radius: 50%;
  display: inline-block;
  background-color: red;
}
.black-dot {
  height: 10px;
  width: 10px;
  border-radius: 50%;
  display: inline-block;
  background-color: #111610;
}
.slider-icon {
  outline: none !important;
}
.search-bar .input-group-prepend .input-group-text {
  height: 38px;
  border-radius: 0;
  font-family: "Source Sans Pro", sans-serif;
  border: 1px solid #ced4da;
  background: #f4f4f4;
  font-size: 15px;
  cursor: pointer;
}

.search-bar .form-control {
  height: 38px;
  width: 30px !important;
  border-radius: 0;
  border: 1px solid #ced4da;
  font-size: 18px;
  font-family: "Source Sans Pro", sans-serif;
}

.search-bar .form-control:focus {
  box-shadow: none;
}
.search-bar {
  width: 30% !important;
}
.add-gst-button {
  background-color: #0e5d84;
  font-size: 14px;
  font-weight: 600;
  border-color: none !important;
  width: 130px !important;
}
.sumbit-approval {
  background-color: #0e5d84;
  font-size: 14px;
  font-weight: 600;
  color: #ffffff !important;
  border-color: none !important;
}
.save-gst-button {
  background-color: #0e5d84;
  font-size: 14px;
  font-weight: 500;
  border-color: none !important;
  color: #ffffff !important;
  width: 164px;
  /* width: 130px !important; */
}
.save-gst-button:disabled {
  cursor: not-allowed;
}
.partner-reg {
  font-family: "Source Sans Pro", sans-serif !important;
  font-size: 15px;
  text-align: left;
  color: #696969;
}
.partner-reg-subText {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 16px;
  font-weight: bold;
  text-align: left;
  color: #212529;
}
.sub-heading-text {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 18px;
  font-weight: bold;
  text-align: left;
  color: #212529;
}
</style>
<style>
.modal-header {
  padding: 5px !important;
  background-image: linear-gradient(to bottom, #1d76ae, #055396);
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.modal-title {
  /* font-family: "Source Sans Pro", sans-serif !important; */
  font-size: 16px !important;
  font-weight: 500;
  color: #ffffff;
}
.modal-dialog-scrollable .modal-body {
  overflow-y: auto;
  overflow-x: hidden;
}
.modal-footer {
  padding: 8px;
  /* margin-left: 4%;
  margin-right: 5%; */
  border-top: 1px solid #dee2e6;
  font-family: "Source Sans Pro", sans-serif;
}
/* .modal-footer > .btn-primary {
  background-color: #0e5d84;
  font-size: 14px;
  font-weight: 500;
  border-color: none !important;
  color: #ffffff !important;
  width: 164px;
  margin-right: 2%;
} */

.custom-control-input:checked ~ .custom-control-label > span {
  font-family: "Source Sans Pro", sans-serif !important;
  font-size: 15px !important;
  font-weight: bold;
  text-align: left;
  color: #002d72 !important;
}
.custom-control-input ~ .custom-control-label > span {
  font-family: "Source Sans Pro", sans-serif !important;
  font-size: 15px !important;
  /* font-weight: bold; */
  text-align: left;
  /* color: #002d72 !important; */
}
.approved-gst {
  /* width: 23%; */
  /* float: left; */
  height: 18px !important;
}
.alertText {
  font-family: "Source Sans Pro", sans-serif;
  font-weight: 600;
  font-size: 18px;
  text-align: center !important;
}
.modal-header .close {
  margin-top: 1px !important;
  padding: 0rem 0rem 0px !important;
  margin: -1rem -1rem -1rem auto;
  border: solid 1px #707070;
  /* color: rgba(0, 0, 0, 0.85); */
  font-family: "Source Sans Pro", sans-serif;
  color: red;
  border-radius: 50%;
  background-color: #ffff;
  margin: 0.5px 0px 0px 5px !important;
  width: 18px;
  font-size: 17px;
  font-weight: bold;
  opacity: unset !important;
}

.card-background {
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.16);
  background-color: #ffffff;
}
.sub-heading-text {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 18px;
  font-weight: bold;
  text-align: left;
  color: #212529;
}
.add-pbc-button {
  background-color: #0e5d84;
  font-size: 14px;
  font-weight: 600;
  border-color: none !important;
}
.submit-pbc-approval {
  background-color: #0e5d84;
  font-size: 14px;
  font-weight: 600;
  color: #ffffff !important;
  border-color: none !important;
}
.save-pbc-btn {
  background-color: #0e5d84;
  font-size: 14px;
  font-weight: 500;
  border-color: none !important;
  color: #ffffff !important;
  width: 120px;
}
.save-pbc-btn:disabled {
  cursor: not-allowed;
}
.headings-multi-select {
  font-size: 12px !important;
  font-weight: bold !important;
  letter-spacing: 0.2px !important;
  color: #484848 !important;
}
.secondary-account-modal {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 15px;
  text-align: left;
  color: white;
  background-image: linear-gradient(to bottom, #1d76ae, #055396);
  height: 30px !important;
  vertical-align: middle;
  letter-spacing: 0.5px;
}
.secondary-close {
  position: absolute;
  right: 6px;
  top: 5px;
  background-color: white;
  border-radius: 15px;
  width: 18px;
  height: 18px;
}
.content-height-modal {
  height: 400px !important;
}
</style>
<style>
.modal-header {
  padding: 5px !important;
  background-image: linear-gradient(to bottom, #1d76ae, #055396);
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.modal-title {
  /* font-family: "Source Sans Pro", sans-serif !important; */
  font-size: 16px !important;
  font-weight: 500;
  color: #ffffff;
}
.modal-dialog-scrollable .modal-body {
  overflow-y: auto;
  overflow-x: hidden;
}
.modal-footer {
  padding: 8px;
  /* margin-left: 4%;
  margin-right: 5%; */
  border-top: 1px solid #dee2e6;
  font-family: "Source Sans Pro", sans-serif;
}
/* .modal-footer > .btn-primary {
  background-color: #0e5d84;
  font-size: 14px;
  font-weight: 500;
  border-color: none !important;
  color: #ffffff !important;
  width: 164px;
  margin-right: 2%;
} */

.custom-control-input:checked ~ .custom-control-label > span {
  font-family: "Source Sans Pro", sans-serif !important;
  font-size: 15px !important;
  font-weight: bold;
  text-align: left;
  color: #002d72 !important;
}
.custom-control-input ~ .custom-control-label > span {
  font-family: "Source Sans Pro", sans-serif !important;
  font-size: 15px !important;
  /* font-weight: bold; */
  text-align: left;
  /* color: #002d72 !important; */
}
.approved-gst {
  /* width: 23%; */
  /* float: left; */
  height: 18px !important;
}
.alertText {
  font-family: "Source Sans Pro", sans-serif;
  font-weight: 600;
  font-size: 18px;
  text-align: center !important;
}
.modal-header .close {
  margin-top: 1px !important;
  padding: 0rem 0rem 0px !important;
  margin: -1rem -1rem -1rem auto;
  border: solid 1px #707070;
  /* color: rgba(0, 0, 0, 0.85); */
  font-family: "Source Sans Pro", sans-serif;
  color: red;
  border-radius: 50%;
  background-color: #ffff;
  margin: 0.5px 0px 0px 5px !important;
  width: 18px;
  font-size: 17px;
  font-weight: bold;
  opacity: unset !important;
}
</style>

<style>
.thClassLeft {
  background-color: #6192b1;
  color: white;
  text-align: left !important;
}
.thClassright {
  background-color: #6192b1;
  color: white;
  text-align: right !important;
}

.thClassCenter {
  background-color: #6192b1;
  color: white;
  text-align: center !important;
}
.table-action {
  background-color: #6192b1;
  width: 7% !important;
}
/* .dottedGreen {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #28b915;
  float: left;
  margin-top: 3%;
}
.dottedPending {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #f4cf08;
  float: left;
  margin-top: 7%;
}
.dottedRejected {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #e61313;
  float: left;
  margin-top: 3%;
}
.dottedSendback {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #002d72;
  float: left;
  margin-top: 3%;
} */
.vueperslides__arrow--next,
.vueperslides__arrow {
  background: linear-gradient(90deg, #fff, #8dbbe0, #fff) !important;
  padding: 20px 0px !important;
  color: #fff !important;
}

.vueperslides__arrow--next:focus,
.vueperslides__arrow:focus {
  border: none !important;
  outline: 0px !important;
}
.vueperslides__arrow--next img,
.vueperslides__arrow img {
  transform: scale(2);
  filter: brightness(0.5);
}
.activeFilterTab {
  font-weight: bold;
  text-decoration: underline;
  color: #000 !important;
}
</style>
<style scoped>
.disabled {
  opacity: 0.9;
}
</style>